{
    "deviceCommandThrottled": {
        "macroLength": "This connection does not allow long macros. Your macro has been shortened automatically.",
        "commandCount": "This connection limits how fast you can send commands. Please wait and try again soon."
    },
    "logo": "Cephable logo",
    "add": "Add",
    "all": "All",
    "edit": "Edit",
    "create": "Create",
    "delete": "Delete",
    "previous": "Previous",
    "next": "Next",
    "search": "Search",
    "loading": "Loading...",
    "reload": "Reload",
    "cancel": "Cancel",
    "copy": "Copy",
    "save": "Save",
    "reset": "Reset",
    "deprecated": "Deprecated",
    "saveAndFinish": "Save and Finish",
    "saveAndContinue": "Save and Continue",
    "saved": "Saved",
    "saveError": "Error saving changes.",
    "done": "Done",
    "back": "Back",
    "play": "Play",
    "pause": "Pause",
    "resume": "Resume",
    "success": "Success",
    "continue": "Continue",
    "options": "Options",
    "share": "Share",
    "finish": "Finish",
    "description": "Description",
    "expand": "Expand",
    "expandMenu": "Expand Menu",
    "finishEdit": "Finish Edit",
    "advancedOptions": "View Advanced Options",
    "authenticating": "Authenticating...",
    "skipToMain": "Skip to Main Content",
    "skip": "Skip",
    "close": "Close",
    "notFound": "Page Not Found",
    "notFoundDescription": "Oh noes! We have searched the sea and we can't find thee page!",
    "exitSetup": "Exit Setup",
    "experimental": "Experimental",
    "letGetStarted": "Let's get started!",
    "exploreInputControls": "Explore Input Controls",
    "when": "When I ...",
    "thenMacro": "Cephable will run...",
    "controls": "Controls",
    "welcome": "Welcome.",
    "beta": "beta",
    "macroEmpty": "There are no macros matching this criteria.",
    "you": "You",
    "step": "Step",
    "steps": "Steps",
    "learnMore": "Learn More",
    "dangerZone": "Danger Zone",
    "connected": "Connected",
    "notConnected": "Not Connected",
    "connectAndLearn": "Connect & Learn",
    "tryAgain": "Try Again",
    "by": "By: {{value}}",
    "noName": "- no name -",
    "details": "Details",
    "controlFeed": "Control Feed",
    "upgrade": "Upgrade",
    "purchase": "Purchase",
    "results": "Results",
    "explore": "Explore",
    "created": "Created: {{value}}",
    "updated": "Updated: {{value}}",
    "deleted": "Deleted: {{value}}",
    "expires": "Expires: {{value}}",
    "expired": "Expired: {{value}}",
    "used": "Used: {{value}}",
    "generate": "Generate",
    "stop": "Stop",
    "clear": "Clear",
    "rewrite": "Rewrite",
    "translate": "Translate",
    "inputMethod": "Input Method: ",
    "info": "More Information",
    "view": "View",
    "control": "Control",
    "automate": "Automate",
    "mobileApp": {
        "title": "Mobile App"
    },
    "dashboard": {
        "title": "Dashboard"
    },
    "publicTag": "Public",
    "invalidNumber": "N/A",
    "wifi": {
        "disconnected": "Wi-Fi is disconnected.",
        "connected": "Wi-Fi is connected.",
        "description": "Connect to Wi-Fi to enable Cephable to work with your connections and software. You may have limited ability to use your current controls. "
    },
    "signalR": {
        "disconnected": "Syncing is disconnected.",
        "description": "There appears to be a problem with Cephable syncing. This will cause issues saving your settings or communicating with other connections.",
        "action": "Reconnect",
        "disconnectedDevice": "Unable to sync with {{name}}.",
        "disconnectedDeviceDescription": "There appears to be a problem with syncing either because of authentication or internet connectivity. You can not remotely send or receive data. You need to check both sides of the connection.",
        "connected": "Syncing is connected.",
        "connectedDescription": "Cephable is syncing properly and should be communicating with your connections and extensions as expected.",
        "swap": "Swap to local device connection",
        "unlinkedDevice": "Connection removed.",
        "unlinkedDeviceDescription": "This connection has been unlinked from your account."
    },
    "billing": {
        "title": "Billing",
        "expires": "Next Billing: {{value}}",
        "description": "Manage your organization billing, seats, subscription upgrades, renewal, or cancellation.",
        "error": "Please contact your system administrator to manage your billing.",
        "view": "Manage Billing",
        "included": "Included with your {{licenseType}} license.",
        "mostPopular": "Most Popular",
        "upgrade": {
            "description": "Upgrade now and take your controls to the next level.",
            "longDescription": "Upgrade to a paid license to unlock all of the features of Cephable. From multiple devices, to advanced controls, to custom integrations, Cephable has everything you need to take you to the next level of productivity.",
            "action": "Upgrade Now",
            "compare": "Compare Plans",
            "error": "Error upgrading. Please try again later.",
            "requiredDetail": "A {{licenseType}} license is required for this feature. You can always upgrade or start a free trial in your Account Settings.",
            "enableTextGeneration": "Upgrade to generate, edit, and translate content using our Intelligent Tasks.",
            "enableAiDictation": {
                "title": "Upgrade to Intelligent Dictation",
                "description": "Upgrade to unlock AI enhanced dictation. I can add punctuation, fix capitalization, and adapt to your style so your writing looks polished without extra effort."
            }
        },
        "isPlusAccess": {
            "short": "Plus",
            "title": "Plus",
            "titleLong": "Cephable Plus",
            "description": "Cephable Plus is for power users who want to push more with intelligent voice, intelligent dictation, 100's of app controls, and more.",
            "supportedFeatures": {
                "tag": "Everything in Basic, plus",
                "features": [
                    "Intelligent Voice Controls (Natural Language)",
                    "Intelligent Dictation (AI Enhanced)",
                    "Install on up to 3 Devices",
                    "100's of Pre-trained App Controls"
                ]
            }
        },
        "isEmployeeAccess": {
            "short": "Pro",
            "title": "Professional",
            "titleLong": "Cephable Professional",
            "description": "Cephable professional empowers users with more productivity power, extending the local, private AI to generative capabilities.",
            "supportedFeatures": {
                "tag": "Everything in Plus, plus",
                "features": [
                    "AI Text Generation",
                    "AI Rewrite",
                    "AI Translate",
                    "Unlimited Device Installs",
                    "Unlimited Pre-trained App Controls",
                    "Unlimited Sharing of Controls"
                ]
            }
        },
        "personal": {
            "short": "Basic",
            "title": "Basic",
            "titleLong": "Cephable Basic",
            "description": "Cephable Basic is free forever and built to help you move faster, express yourself, and get stuff done—your way. Features included in basic are available to all users.",
            "upgrade": {
                "title": "Take your controls to the next level",
                "description": "Upgrade to Plus or Pro to unlock all of my features. More accuracy. More connections. More controls. More power to take your productivity to the next level.",
                "featureHeading": "Here's how I can help you:",
                "control": "I move you through apps and tools faster using your voice or quick actions — no broken flow. With Intelligent Voice we can just chat.",
                "create": "I rewrite, dictate, generate, and translate directly inside your apps — no copying, pasting, or screen switching needed.",
                "automate": "I run intelligent tasks and quick actions that speed up your workflow. From simple commands to complex macros, I can do the heavy lifting so you can focus on the work that matters.",
                "local": "All local AI. No cloud processing."
            }
        },
        "isDeveloperAccess": {
            "short": "SDK",
            "title": "SDK",
            "titleLong": "Cephable SDK",
            "description": "Cephable SDKs let you integrate powerful adaptive controls— voice, face, head, and more into your software with minimal lift and maximum payoff.",
            "supportedFeatures": {
                "tag": "Everything in Plus, plus",
                "features": [
                    "Windows and MacOS support",
                    "Lightweight, embeddable SDKs for offline voice, face, head, and quick action input",
                    "API/webhook support for custom output actions",
                    "Developer docs",
                    "Sample projects",
                    "Turn commands into document automation and navigation",
                    "Developer Portal for managing your projects, auth clients, device types, and more"
                ]
            }
        },
        "isStudentAccess": {
            "short": "Edu",
            "title": "Student",
            "titleLong": "Cephable Education",
            "description": "Cephable Education supports personalized learning and inclusive classrooms. Cephable works offline, runs on-device, and requires no third-party integrations.",
            "supportedFeatures": {
                "tag": "Everything in Plus, plus",
                "features": [
                    "Unlimited device installs",
                    "Unlimited pre-trained app controls",
                    "Unlimited sharing of custom app controls"
                ]
            }
        },
        "isResellerAccess": {
            "short": "Reseller",
            "title": "Reseller",
            "titleLong": "Cephable Reseller",
            "description": "Cephable Reseller is a paid license that allows you to create new organizations and assign license keys. This includes using Cephable with your own software suite and improving your user experience."
        },
        "viewProducts": "View Products",
        "subscription": {
            "options": "Subscription Options",
            "monthly": "Pay Monthly",
            "billedMonthly": "/month",
            "yearly": "Pay Yearly",
            "billedYearly": "/year"
        }
    },
    "organization": {
        "title": "Organization",
        "titlePlural": "Organizations",
        "titleLong": "Cephable Professional for Organizations",
        "description": "Organizations are groups of users who can collaborate on projects and share resources. You can manage your team, team profiles, billing and more here.",
        "viewOrganization": "View Organization",
        "orgName": "Organization Name",
        "orgCustomBillingUrl": {
            "title": "Custom Billing URL",
            "description": "This is a custom URL that will be used to redirect the user to your (the reseller's) billing system. Should begin with 'https://' or 'mailTo:'"
        },
        "create": "Create New Organization",
        "managed": {
            "title": "Managed Organization",
            "titleShort": "Managed",
            "titlePlural": "Managed Organizations",
            "description": "Managed organizations are organizations that are managed by a Cephable Reseller. Resellers can manage your team, team profiles, billing and more here.",
            "error": "Error loading managed organizations.",
            "empty": {
                "title": "No managed organizations found.",
                "description": "It doesn't look like there are managed organizations matching this criteria. Or your license keys have not been activated yet."
            }
        },
        "settings": {
            "title": "Organization Settings",
            "description": "Manage your organization billing, name, description, and resources.",
            "view": "View Settings",
            "general": {
                "title": "General"
            },
            "resources": {
                "edit": "Edit Resources",
                "description": "Use the Markdown editor on the left to update and format helpful resources for all members of the organization. As you type, the preview on the right will show how your content will appear to users. You can add headings, lists, links, and other formatting elements using Markdown syntax. Changes will be visible to members once saved."
            },
            "other": {
                "title": "Other Settings",
                "description": "Manage your organization billing, name, description, and resources."
            }
        },
        "menu": {
            "title": "Organization Menu",
            "view": "View Menu",
            "expand": "Expand Menu"
        },
        "update": "Your organization has been updated! Refreshing the app.",
        "noAccess": {
            "title": "Access denied.",
            "description": "Your permissions have recently changed and you no longer have access to this feature. If you believe this is an error, please contact your organization administrator."
        },
        "noOrg": {
            "title": "No associated license.",
            "description": "You are not currently associated with a license or developer group. The portal is limited to users with a paid Cephable License. To unlock the full potential of Cephable start a risk free trial."
        },
        "error": "Error loading Organization. Please try again later.",
        "member": {
            "title": "Member",
            "titlePlural": "Members",
            "orgTitle": "{{value}} Members",
            "me": "My Membership",
            "aboutMe": "About Me",
            "description": "Members are users who are part of your organization. They can be assigned to different roles and have access to different parts of the organization.",
            "edit": "Edit Members",
            "removed": "You have been removed from a team.",
            "removedDescription": "You have been removed from the team. You can no longer access the organization. If you believe this is an error, please contact your organization admin.",
            "updated": "Success, {{value}}'s membership has been updated.",
            "error": "Error updating {{value}}'s membership.",
            "delete": "Success, {{value}} has been removed.",
            "deleteError": "Error removing {{value}}.",
            "loadError": "Error loading organization members.",
            "deleteConfirmation": {
                "title": "Are you sure you want to remove this member?",
                "description": "Once you remove this member, they will no longer have access to the organization. You can always re-invite them later.",
                "confirm": "Yes, remove member"
            },
            "viewAll": {
                "title": "View All Members",
                "description": "View all members of your organization and manage their roles and permissions."
            },
            "seats": {
                "title": "Member Seats",
                "description": "Every member in your organization counts as a seat. The type of permissions they have can be changed by the organization admin.",
                "stats": "seats out of {{value}}",
                "max": "Max seats",
                "maxSeatValue": "Max seats: {{value}}",
                "current": "Current Seats",
                "limit": {
                    "title": "Maximum Seats Reached",
                    "description": "Your current plan has reached its limit of {{ maxSeats }} available seats. You are unable to invite additional members. Please contact your administrator to upgrade the plan or manage your seat allocation."
                },
                "updateLimit": {
                    "title": "Upgrade Your Plan to Add More Seats",
                    "description": "Your current plan has reached the maximum number of seats: {{ maxSeats }}. Upgrade now to unlock additional seats and ensure your team can continue to grow seamlessly.",
                    "action": "Upgrade Plan"
                }
            },
            "emailExists": "Email already exists in the organization. Please enter a different email address."
        },
        "invite": {
            "title": "Invite",
            "titlePlural": "Invites",
            "orgTitle": "{{ value }} Invites",
            "description": "Invites are sent to users to join your organization. You can invite users to join your organization and assign them to different roles.",
            "edit": "Add a Member",
            "view": "View All Invites",
            "viewDescription": "See all current invites that have not been accepted.",
            "new": "Invite a Member",
            "editDescription": "Create a new invite for a user to join your organization.",
            "emailRequired": "Email is required",
            "emailInvalid": "Email is invalid. Please enter a valid email address.",
            "emailExists": "Email already has an organization invite. Please enter a different email address.",
            "emailPlaceholder": "Enter email address",
            "expiration": "Expires ",
            "delete": "Delete Invite",
            "confirm": "Are you sure you want to remove this invitation?",
            "confirmLong": "Once you delete this invite, the user will no longer be able to join the organization. You can always re-invite them later.",
            "accept": "Accept Invite",
            "stat": "active invitations",
            "error": "Error loading invites.",
            "noInvites": {
                "title": "No invites.",
                "description": "It looks like there are no active invites for your organization."
            },
            "acceptSuccess": {
                "title": "Welcome to the team.",
                "description": "You have successfully joined the organization. ",
                "action": "View your new organization"
            },
            "acceptError": {
                "title": "Oops. Looks like there is a problem.",
                "description": "There was an error joining the organization. Please try again later. If the issue persists, please reach out to your organization admin. ",
                "action": "Back to the homepage"
            },
            "send": {
                "title": "Send Invite",
                "success": "Invite to {{value}} sent.",
                "error": "Error sending invite to {{value}}."
            }
        },
        "role": {
            "title": "Role",
            "titlePlural": "Roles",
            "description": "Roles are the different levels of access that a user can have in your organization. You can assign different roles to users to control what they can do."
        },
        "isAdmin": {
            "title": "Admin",
            "description": "Admins have full access to the organization and can manage all aspects of the organization.",
            "conflict": "This member is an Admin. You do not have permission to edit their roles."
        },
        "canViewMembers": {
            "title": "View Members",
            "description": "Users with this permission can view all members of the organization."
        },
        "canInviteMembers": {
            "title": "Invite Members",
            "description": "Users with this permission can invite new members to the organization and manage existing invites."
        },
        "canChangeMemberPermissions": {
            "title": "Change Member Roles",
            "description": "Users with this permission can change the role of other members in the organization."
        },
        "canRemoveMembers": {
            "title": "Remove Members",
            "titleSingle": "Remove Member",
            "action": "Remove",
            "description": "Users with this permission can remove other members from the organization.",
            "confirm": "Are you sure you want to remove this member from the organization?",
            "confirmLong": "Once you remove this member, they will no longer have access to the organization. You can always re-invite them later."
        },
        "canCreateAuthClients": {
            "title": "Create Projects",
            "description": "Users with this permission can create new auth clients and projects for the organization."
        },
        "canViewAuthClients": {
            "title": "View Projects",
            "description": "Users with this permission can view auth clients and projects for the organization."
        },
        "canManageBilling": {
            "title": "Manage Billing",
            "description": "Users with this permission can manage the billing settings for the organization.",
            "error": "You do not have permission to manage billing for this organization."
        },
        "canManageChildOrganizations": {
            "title": "Manage Child Organizations",
            "description": "Users with this permission can create and manage child organizations as an admin."
        },
        "canAccessOrganizationProfiles": {
            "title": "View Organization App Controls",
            "description": "Users with this permission can view the organization app controls associated with this organization."
        },
        "canEditOrganizationProfiles": {
            "title": "Manage Organization App Controls",
            "description": "Users with this permission can create, edit, and delete organization app controls associated with this organization."
        },
        "canViewAnalytics": {
            "title": "View Analytics",
            "description": "Users with this permission can view the metrics and analytics for the organization."
        },
        "metrics": {
            "title": "Metrics",
            "description": "Metrics are data points that help you understand how your organization is using Cephable.",
            "view": "View Metrics",
            "orgTitle": "{{ value }} Metrics",
            "manage": {
                "title": "Performance Metrics",
                "description": "Download or clear the performance metrics collected during model inference."
            },
            "download": {
                "button": "Download Metrics",
                "success": "Metrics file has been saved to your Downloads folder.",
                "error": "Failed to download metrics file.",
                "noFile": "No metrics file found. Try running the model first."
            },
            "clear": {
                "button": "Clear Metrics",
                "success": "Metrics have been cleared.",
                "error": "Failed to clear metrics file.",
                "confirm": {
                    "title": "Clear Performance Metrics",
                    "description": "Are you sure you want to clear all recorded performance metrics? This action cannot be undone.",
                    "cancel": "Cancel",
                    "confirm": "Clear Metrics"
                }
            },
            "lineChart": {
                "title": "Average Concurrent Connections",
                "description": "This chart shows the average concurrent connections for the organization and project data over time.",
                "max": "Max Connections: {{maxConnections}}",
                "project": "Project Total",
                "org": "Organization Total"
            }
        },
        "profiles": {
            "titleShort": "App Controls",
            "title": "Organization App Controls",
            "description": "Organization App Controls are shared profiles for distributing app controls across your organization or to share with your integration users. ",
            "view": "View Organization App Controls",
            "editDescription": "Edit organization app controls to customize settings.",
            "empty": "No organization app controls found. Create one to get started.",
            "error": "Error loading organization app controls."
        },
        "projects": {
            "title": "Projects",
            "description": "Use Projects to manage secure access, configure device interactions, and streamline how your apps send and receive commands across various platforms.",
            "name": "App Name",
            "view": "View Projects",
            "error": "Error loading projects.",
            "orgTitle": "{{ value }} Projects",
            "stats": {
                "title": "Project Stats",
                "connections": "Total Connections",
                "all": {
                    "title": "All Project Metrics",
                    "description": "Aggregated metrics for all projects associated with {{ orgName }}"
                },
                "card": "projects out of {{value}}",
                "users": "total users since {{date}}",
                "avgUsers": "monthly avg users.",
                "concurrent": {
                    "title": "Average Concurrent Connections Last {{days}} days",
                    "label": "Avg Concurrent",
                    "max": "Max Connections",
                    "overage": "Overage",
                    "description": "Concurrent connections are the number of users connected to your project at the same time. This metric helps you understand how many users are using your app simultaneously."
                }
            },
            "projectType": {
                "title": "Project Type",
                "description": "Project Types are used to categorize your projects and help us choose the right SDKs for you."
            },
            "accessDenied": {
                "generic": "You do not have access to this project.",
                "title": "Access Denied.",
                "description": "You do not have access to view, create, edit or delete projects. Please reach out to your administrator for access."
            },
            "upgrade": {
                "title": "Upgrade to Cephable SDK",
                "description": "Cephable can be integrated directly into your app, game, or service using our SDK’s. Projects are not currently available with your account. If you think there is a mistake, please reach out to support@cephable.com.",
                "shortDescription": "Projects are not currently available with your account. Reach out to upgrade."
            },
            "limit": {
                "title": "Want more projects?",
                "error": "Project limit reached.",
                "description": "You have reached the maximum number of projects for your organization. Please reach out to your administrator to upgrade your account."
            },
            "create": {
                "title": "Create Project",
                "titleLong": "Let’s get started.",
                "first": {
                    "title": "Get started with your project.",
                    "description": "It looks like you haven't created a project yet. Client keys and devices are essential for securing communication between your applications and our services. With a client key, you’ll be able to integrate voice and head motion controls into your apps quickly and securely."
                },
                "details": {
                    "title": "Project Details",
                    "description": "Create a new project to manage your application’s authorization, device capabilities, and SDK integrations. Follow the steps below to set up secure, customizable interactions for your users."
                }
            },
            "sdk": {
                "title": "Download the SDK",
                "description": "Get access to our powerful SDK developed to make adaptive controls easy. ",
                "select": {
                    "title": "Select SDK",
                    "description": "Select the SDK you’d like to use for this project. Our SDKs enable seamless integration of adaptive voice and head motion controls across different platforms."
                }
            },
            "clients": {
                "title": "Authorization Clients",
                "configure": "Configure Authorization Client",
                "description": "Authorization Clients manage secure access for your applications. Define an authorization client to authenticate users and control interactions with your application.",
                "settings": "Authorization Settings",
                "create": "Create Authorization Client",
                "max": "Max Projects: {{value}}"
            },
            "secret": {
                "title": "Client Secret",
                "created": "Your client secret has been created.",
                "description": "Your client secret will only be shown once. Copy it now and store it in a safe secure location. <br> <br> Only use this for your own development. Do not share it with third party services or applications.",
                "copy": "Copy Secret",
                "rotate": {
                    "title": "Rotate Client Secret",
                    "description": "WARNING: This action will revoke your existing client secret and create a new client secret. This will require you to update all of your existing usage through out your apps. This action can not be reversed.",
                    "error": "Error rotating secret. Please try again later."
                }
            },
            "key": {
                "title": "Client Key",
                "view": "View Client Key",
                "copy": "Copy Key",
                "delete": {
                    "title": "Delete Client Key",
                    "description": "WARNING: This action will remove your existing client key and all related settings.This action can not be reversed.",
                    "error": "Error deleting your client key.",
                    "success": "You're project has been deleted. "
                }
            },
            "tokenRedirect": {
                "title": "Token Redirect URLs",
                "description": "Token Redirect URLs are the endpoints where access tokens are sent after authentication is complete. These URLs allow your application to securely receive tokens needed to access user data and services."
            },
            "authRedirect": {
                "title": "Authorization Code Redirect URLs",
                "description": "The AuthCode Redirect URL is the endpoint where authorization codes are sent after a user grants permission to your application. This URL is essential in OAuth flows, as it ensures the secure transmission of the authorization code from the authorization server to your app, allowing you to request access tokens on behalf of the user."
            },
            "originHost": {
                "title": "Origin Host",
                "description": "The URL that will serve as the primary source for request and data during API interactions."
            },
            "scopes": {
                "title": "Scopes",
                "configure": "Define Scopes",
                "titleLong": "API Permission Scopes",
                "manage": "Manage Authorization Scopes",
                "description": "Scopes define the permissions that this authorization client will have. Set scopes to limit access to specific data and functionality, ensuring users only get the access they need."
            },
            "type": {
                "title": "Implementation Type"
            },
            "deviceScopes": {
                "title": "Associated Device Types",
                "titles": "Associated Device Types",
                "titleLong": "Allowed Device Types",
                "configure": "Configure Allowable Device Types",
                "descriptionShort": "Define which type of devices can access this project.",
                "description": "Device Type defines the permissions and access levels that a device has within your application. By assigning specific devices types, you can control the actions and data that each device can access, ensuring that your application remains secure and compliant with your privacy policies.",
                "action": "Add new device type"
            },
            "deviceType": {
                "title": "Device Types",
                "description": "A DeviceType defines a category of devices, detailing their input/output capabilities and supported features (e.g., voice, gesture, controller types). It ensures that only authorized devices can interact with an application.",
                "action": "Create Device Type",
                "name": "Device Type Name",
                "descriptionLong": "Device Type Description",
                "id": "Device Type Id",
                "features": {
                    "title": "Supports Features",
                    "description": "Define the input and outputs that your app supports. This helps us optimize user experience across Cephable.",
                    "supportsVoiceInput": "Voice Input",
                    "supportsPhysicalInput": "Physical Input",
                    "supportsKeyboardOutput": "Keyboard Output",
                    "supportsPlayStationControllerOutput": "PlayStation Controller",
                    "supportsFaceInput": "Face Input",
                    "supportsGestureInput": "Gesture Input",
                    "supportsXboxControllerOutput": "Xbox Controller",
                    "supportsDigitalExtensions": "Digital Extensions",
                    "supportsPhysicalExtensions": "Physical Extensions",
                    "supportsNintendoControllerOutput": "Nintendo Controller",
                    "supportsGenericControllerOutput": "Generic Controller Output"
                },
                "canAutoStart": {
                    "title": "Supports Automatic Control Starts",
                    "description": "[canAutoStart] if enabled, SDK’s will check the user settings and attempt to immediately start camera, or microphone controls after user login."
                },
                "isSupported": {
                    "title": "Active",
                    "description": "[isSupported]  If disabled, Cephable will no longer send, receive or  acknowledge any user devices associated with this. Equivalent to deprecated."
                },
                "throttleRules": {
                    "title": "Command Throttle Rules",
                    "description": "Configure throttle rules to control command flow and input restrictions for this device type.",
                    "disableVoiceInput": "Disable Voice Input",
                    "disableHotkeyInput": "Disable Hotkey Input",
                    "disableCameraInput": "Disable Camera Input",
                    "disableMultiInputs": "Disable Multiple Inputs",
                    "maximumCommandsPerSecond": "Maximum Commands Per Second",
                    "maximumCommandsPerMinute": "Maximum Commands Per Minute",
                    "maximumMacroLength": "Maximum Macro Length"
                },
                "locale": {
                    "title": "Default Language",
                    "description": "[defaultLocale] The default locale for this device type. This will be used as the default language for the device.",
                    "support": "Supports Languages",
                    "warn": "** It looks like you have Custom Controls set up. Please make sure that you have updated the custom controls for the associated languages.**",
                    "name": "{{lang}} - Device Type Name",
                    "langDescription": "{{lang}} - Description"
                },
                "customControls": {
                    "title": "Custom Controls",
                    "description": "Custom Controls are an advanced option for allowing users to manually set up and edit app controls associated with this device. If you are wanting users to control your device from Cephable directly, then you must register your device controls here. Please see Cephable API for complete details on the options.",
                    "object": "{{lang}} - Custom Controls Object"
                },
                "success": {
                    "title": "Success!",
                    "description": "You have created a new Device Type. {{name}} You can now update your authorization client device scope as needed."
                }
            }
        },
        "troubleshooting": {
            "title": "Troubleshooting",
            "editorDescription": "[Optional] This is a section that is visible to all users via the connection details page in both the Cephable mobile and desktop apps.",
            "description": "If you are experiencing issues with Cephable, try the steps below to resolve common problems."
        },
        "onboarding": {
            "title": "Onboarding",
            "editorDescription": "[Optional] Onboarding is displayed to users when this device type is added to their account. This is a great place to provide instructions on how to set up and use the device type with your application."
        },
        "documents": "Documents",
        "completionStatus": {
            "title": "Completion Status",
            "error": "",
            "complete": "Complete.",
            "incomplete": "Incomplete."
        },
        "metadata": {
            "title": "Metadata",
            "urlError": "URL must start with http:// or https://",
            "metatitle": {
                "label": "Meta Title",
                "placeholder": "Enter a short title"
            },
            "shortDescription": {
                "label": "Short Description",
                "placeholder": "Enter a brief preview description (max 150 characters)"
            },
            "externalLink": {
                "label": "External Link URL",
                "placeholder": "https://example.com/device-info",
                "description": "A direct link to an external website or resource that provides more information about setting up this device for the first time. If you use this we will not use the client listing markdown."
            },
            "iconUrl": {
                "label": "Device Icon URL",
                "placeholder": "https://example.com/device-icon.png",
                "description": "A direct link to an image that represents this device type. This icon will be displayed in the Cephable app and on device listings."
            },
            "darkModeIconUrl": {
                "label": "Dark Mode Device Icon URL",
                "placeholder": "https://example.com/device-icon-dark.png",
                "description": "A direct link to an image that represents this device type in dark mode. This icon will be displayed in the Cephable app and on device listings when the user has dark mode enabled."
            },
            "editorDescription": "When your device is chosen to be featured in the Cephable app as an extension or connection, we use this information to display to users setting up new connections."
        },
        "client-listing": {
            "title": "Client Listing",
            "editorDescription": "Detailed instructions for new users to set up new connections with this device type. This markdown content will be displayed in the Cephable app when users are adding a new connection."
        },
        "new": {
            "details": "Organization Details",
            "name": {
                "label": "Organization Name",
                "placeholder": "Enter the name of your organization"
            },
            "description": {
                "label": "Organization Description",
                "placeholder": "What are your goals with using Cephable Professional?"
            }
        },
        "expired": {
            "title": "Your Cephable License has Expired",
            "titlePlural": "Your Cephable Licenses have Expired",
            "user": "It looks like your Cephable License has expired, so you've been downgraded to the free Cephable Basic. To renew, please contact your organization administrator.",
            "admin": "It looks like your Cephable License has expired, so you've been downgraded to the free Cephable Basic. Please renew your license to continue using advanced features beyond Cephable Basic.",
            "multiple": "It looks like your Cephable Licenses have expired, so you've been downgraded to the free Cephable Basic. Please renew at least one of your licenses to continue using advanced features beyond Cephable Basic.",
            "banner": "It looks like your Cephable License has expired, so you've been downgraded to the free Cephable Basic. By renewing, gain access to features like enhanced voice controls, AI Intelligent Tasks, and many prebuilt app controls.",
            "dialog": {
                "title": "Select an Organization",
                "description": "You have multiple organizations associated with your account. Please select the organization you would like to renew."
            }
        },
        "upgrade": {
            "existing": {
                "title": "You are part of an existing license.",
                "description": "Please upgrade by clicking `{{action}}` on the side menu."
            }
        },
        "restrictions": {
            "isGenAIDisabled": {
                "title": "Generative AI Disabled",
                "description": "Your organization has disabled access to Generative AI features. Please contact your organization administrator for more information."
            },
            "isRemoteControlDisabled": {
                "title": "Cross Device Syncing Disabled",
                "description": "Your organization has disabled access to syncing, you will not be able to use our companion app or control external devices. Please contact your organization administrator for more information."
            }
        }
    },
    "developer": {
        "title": "Developer",
        "titleLong": "Developer Resources",
        "description": "Cephable can be integrated directly into your app, game, or service using our SDK’s.",
        "sdk": {
            "title": "Explore Our SDKs",
            "description": "We provide first-class SDKs designed to seamlessly integrate voice recognition and adaptive controls into your applications. Our tools are crafted to enhance user interaction through intuitive controls and to foster accessibility, ensuring that your software can be operated more effectively by all users.",
            "javascript": {
                "title": "JavaScript",
                "subtitle": "Web",
                "description": "Integrate voice and adaptive controls directly into your web applications.",
                "action": "Get NPM Package"
            },
            "net": {
                "title": ".NET",
                "subtitle": "Windows Applications",
                "description": "Leverage the power of .NET to create applications with our WPF and WinUI3 SDKs.",
                "actionCore": "Get Core Package",
                "actionWpf": "Get WPF Package"
            },
            "android": {
                "title": "Android",
                "subtitle": "Mobile Devices",
                "description": "Android applications designed to facilitate  voice and head motion capabilities.",
                "action": "Get Android SDK"
            },
            "more": {
                "title": "More",
                "description": "Not finding what you need? Reach out and we can help you.",
                "action": "Request a SDK"
            }
        },
        "demo": {
            "title": "Demos",
            "samples": "Demos and Samples",
            "titleLong": "Experience Our SDKs in Action",
            "description": "Discover the power of our voice and head motion control technologies through our sample applications. From interactive games to dynamic web and mobile apps, each example demonstrates the versatility and effectiveness of our SDKs. Explore these examples to gain insights and inspiration for integrating enhanced accessibility and immersive experiences into your own projects.",
            "game": {
                "title": "2048 Game",
                "subtitle": "Web",
                "description": "Elevate traditional gameplay with adaptive voice and head motion controls.",
                "action": "Play the Game"
            },
            "other": {
                "title": "Other Demos",
                "description": "Experience firsthand how Cephable can your enhance your application, game or device.",
                "action": "View More Demos"
            },
            "web": {
                "title": "Web SDK Samples",
                "subtitle": "Web",
                "description": "Straightforward integration of all our core functionality into web applications.",
                "action": "Experience the SDK"
            },
            "unity": {
                "title": "Unity",
                "subtitle": "Game Development",
                "description": "See how adaptive controls can be leveraged in gaming to provide a more engaging UX.",
                "action": "Get the Sample"
            }
        },
        "other": {
            "title": "Other Resources",
            "description": "Not finding what you need in our SDK’s try working directly with out API’s or reach out the community for help, inspiration and support.",
            "api": {
                "title": "API",
                "description": "Our API’s allow you to interact with Cephable directly. You can use our API’s to create custom integrations."
            },
            "support": {
                "title": "Support",
                "description": "Not finding what you need? Reach out to our community via Discord.",
                "action": "Join Discord"
            }
        }
    },
    "customControls": {
        "title": "Global & Device Controls",
        "warn": "Microphone has not been started. You must start your microphone to use global and device controls.",
        "descriptionShort": "Global and device controls are always-available actions designed to work across any software. Global controls—like 'Stop Camera'—are system-wide and app-independent, while device controls are tailored to each device connection and unlock more advanced features than standard app controls.",
        "description": "Global and device controls are always-available actions designed to work across any software. Global controls—like 'Stop Camera'—are system-wide and app-independent, while device controls are tailored to each device connection and unlock more advanced features than standard app controls. These controls are currently accessed as voice controls, however in the future we will add support for other inputs.",
        "prefixDisclaimer": " This is a prefix control; it will listen to the words after the command and then search against the following phrase to find matches.",
        "allowPausedDisclaimer": " This control will work even when the microphone is paused.",
        "noDevice": "This step uses a custom extension that you haven't configured for your account. Add the extension to unlock this step.",
        "resetControls": {
            "title": "Reset Controls",
            "description": "Your voice language has changed since the last time you updated your controls. Note: This will reset your controls to match {{language}}, and you may lose any custom commands. Are you sure you want to reset?",
            "confirm": "Yes, reset controls",
            "error": "There was an error resetting your controls. Please try again later."
        },
        "conflictIndicators": {
            "warn": "Warning: ",
            "title": "Input configuration conflicts detected",
            "description": "Some of the inputs for your global & device controls you are using are also used in one or more of your app controls. This may cause conflicts when using Cephable. When this occurs we will always give preference to the app control over the global or device control.",
            "item": "The input <strong> {{value}} </strong> is used in your app controls: ",
            "globalControls": "Global Control Configuration Conflicts",
            "deviceControls": "Device Control Configuration Conflicts",
            "globalDescription": "The following global controls have conflicting inputs with your app controls.",
            "deviceDescription": "The following device controls have conflicting inputs with your app controls.",
            "usedInput": " is used as an input for "
        },
        "globalControls": {
            "title": "Global Controls",
            "description": "Global controls are controls that are always available no matter what app controls or device you are using. Some even work when your microphone or camera controls are paused.",
            "empty": "You have no global controls yet. Click below to create one.",
            "edit": "Edit Global Controls"
        },
        "deviceControls": {
            "title": "Device Controls",
            "description": "Device controls are tied to the specific device or connection you're using. They’re available without needing to add them to your app controls and are especially useful for features or events that are only supported on certain devices.",
            "empty": "You have no device controls yet. Click below to create one.",
            "edit": "Edit Device Controls",
            "controls": {
                "cephable-open-app": {
                    "success": "Open app: {{value}}",
                    "error": "Unable to find app: {{value}}"
                },
                "cephable-close-app": {
                    "commands": ["close"],
                    "name": "Close App By Name",
                    "description": "Use this command with voice controls to close an app on your computer by name.",
                    "success": "Close app: {{value}}",
                    "error": "Unable to find app: {{value}}"
                },
                "cephable-minimize-focused-app": {
                    "commands": ["minimize"],
                    "name": "Minimize the current app in focus.",
                    "description": "Use this command with voice controls to minimize the current app in focus.",
                    "success": "Minimize focused app success!",
                    "error": "Error minimizing focused app."
                },
                "cephable-maximize-focused-app": {
                    "commands": ["maximize"],
                    "name": "Maximize the current app in focus.",
                    "description": "Use this command with voice controls to maximize the current app in focus.",
                    "success": "Maximize focused app success!",
                    "error": "Error minimizing focused app."
                },
                "cephable-close-focused-app": {
                    "commands": ["close current"],
                    "name": "Close the current app in focus.",
                    "description": "Use this command with voice controls to close the current app in focus.",
                    "success": "Close current app success!",
                    "error": "Error closing current app."
                },
                "cephable-generate-text": {
                    "commands": ["generate"],
                    "name": "Generate text by providing the prompt following this command.",
                    "description": "Use this command with voice controls followed by your prompt to generate some related text."
                },
                "cephable-rewrite-text": {
                    "commands": ["rewrite"],
                    "name": "Rewrite text by providing the prompt following this command.",
                    "description": "Use this command with voice controls followed by your prompt to rewrite your current highlighted text."
                },
                "cephable-summarize-text": {
                    "commands": ["summarize"],
                    "name": "Summarize text by providing the prompt following this command.",
                    "description": "Use this command with voice controls followed by your prompt to summarize your current highlighted text."
                },
                "cephable-translate-text": {
                    "commands": ["translate"],
                    "name": "Translate text by providing the prompt following this command.",
                    "description": "Use this command with voice controls followed by your prompt to translate your current highlighted text."
                },
                "cephable-stop-generate-text": {
                    "commands": ["stop generate", "stop generation", "cancel generate", "cancel generation"],
                    "name": "Stop generating text.",
                    "description": "Use this command with voice controls to stop generating text"
                },
                "cephable-open-panel": {
                    "commands": ["show panel"],
                    "name": "Open the Cephable panel",
                    "description": "Use this command with voice controls to open the Cephable panel."
                },
                "cephable-close-panel": {
                    "commands": ["hide panel"],
                    "name": "Hide the Cephable panel",
                    "description": "Use this command with voice controls to hide or minimize the Cephable panel."
                },
                "cephable-click-by-name": {
                    "commands": ["tap", "hit", "navigate to", "go to"],
                    "name": "Tap Element By Name",
                    "description": "Tap something on the page by name, such as \"tap save\" to click a button named \"save\""
                }
            }
        },
        "changeProfile": {
            "success": "Change app controls: {{value}}",
            "error": "Unable to find app controls: '{{value}}'"
        }
    },
    "notifications": {
        "title": "Notifications",
        "center": "Notification Center",
        "empty": "You have no notifications at this time. Check back another time.",
        "seen": "Seen",
        "markAsRead": "Mark as Read",
        "view": "View All {{value}} Notifications"
    },
    "unsaved": {
        "title": "You have unsaved changes.",
        "description": "You have unsaved changes. Are you sure you want to leave this page?",
        "cancel": "Exit without saving",
        "confirm": "Save and Exit"
    },
    "login": {
        "welcome": "Welcome to Cephable!",
        "subtitle": "Control your technology on <strong>your</strong> terms.",
        "description": "Take full control of your computer, apps, and games with Cephable — your personal AI for fast actions, voice commands, facial expressions, gestures, tilt, and more. No cloud processing. Just seamless control that moves with you.",
        "create": "Create Account",
        "signIn": "Sign In",
        "loading": "Redirecting to sign in...",
        "error": "There was an error signing you in. Please sign in again.",
        "existingAccount": "Already have an account?"
    },
    "home": {
        "title": "Home",
        "startControls": "Turn it on!",
        "manage": "Configure",
        "profileGenerate": {
            "title": "Oops. Looks like you don't have any app controls yet.",
            "description": "In order for Cephable to control your computer, we need to know what you want to control. You can create app controls from scratch or have us help you create one using our control generator."
        }
    },
    "wizard": {
        "title": "Generate App Controls",
        "titleLong": "Generate New App Controls",
        "description": "Cephable will then use this information to generate controls for you to review and try!",
        "includeDefaultKeysQuestion": "Include default voice commands for keys and mouse clicks?",
        "try": "Try Control Generator",
        "placeholder": "Make sure the voice commands are short.\n\nI want to be able to say \"forward\" to go to the next slide in the presentation\n\nI want to use head movement for moving the cursor and voice controls for editing shortcuts\n\nAdd quick action buttons for all my character movement and abilities.",
        "placeholderAppName": "Microsoft Word, Minecraft, YouTube, Code, etc.",
        "noOptionsText": "Begin typing to find an app you want to control",
        "generate": "Generate Controls",
        "complete": {
            "title": "Alright, we're done!",
            "description": "Click the button below to view the controls we generated. You'll be able to manually edit, add to, or remove any aspects to perfect it for yourself.",
            "viewControls": "See my controls"
        },
        "error": {
            "emptyInput": "Please select at least one input method",
            "emptyApp": "Please enter at least one app name",
            "generatingProfile": "Error generating app controls"
        },
        "loading": {
            "title": "We're putting together all the pieces",
            "description": "This can take up to about a minute. Don't leave this page or go back or it will stop generating."
        },
        "selectedTips": {
            "title": "Tip #{{count}}",
            "previous": "Previous Tip",
            "next": "Next Tip",
            "one": "Did you know you can use Cephable on one device to control another? Download Cephable to your mobile, tablet or even another computer and choose the connection you want to control (perhaps this one). Your personal and input profiles are consistent across them all! Just make sure Cephable is running on your device and connections.",
            "two": "You can control the sensitivity of your inputs in the \"Expression Control Settings\" section of the main panel. This let's you further refine the ways Cephable interprets inputs specific to you. And Cephable get's better over time as it works with you!",
            "three": "After we set this up you still have complete control over the configuration. We're giving you a baseline but at any point you can change the mapping between what you do and what it does on the computer.",
            "four": "You can print out your controls to have a physical copy as you use Cephable. We know this is all new and takes some getting used to. Practice makes better!"
        },
        "steps": {
            "one": "Step 1. Type the name of an app you want to control.",
            "two": "Step 2. Confirm the input controls you want to use:",
            "three": "Step 3. (optional) ",
            "threeContinued": "Describe any specific actions you'd like to have setup for commands you commonly use or have a strong preference for. Please use plain english like the ones below"
        }
    },
    "profile": {
        "title": "App Controls",
        "titlePlural": "App Controls",
        "titlePreview": "Controls Preview",
        "previous": "Previous App Controls",
        "manage": "Manage App Controls",
        "view": "View Controls",
        "edit": "Edit App Controls",
        "add": "Add App Controls",
        "create": "Create App Controls",
        "customize": "Customize App Controls",
        "warn": "Camera or microphone must be started to use your app controls.",
        "descriptionShort": "Discover the different ways Cephable helps you control your devices and software.",
        "description": "App controls are a set of controls that you can use to control your device or connection. You can create multiple app controls and switch between them whenever you'd like.",
        "name": "App Name",
        "nameQuestion": "What do you want to call these app controls?",
        "newName": "New App Controls",
        "search": "Search App Controls by Name",
        "searchLong": "Search App Controls by Name or Description",
        "keyboardAndMouse": "Keyboard and Mouse",
        "genericController": "Gamepad Controller",
        "keyboardMouseAndController": "Keyboard, Mouse, and Controller",
        "permissionError": "You do not have permission to use these app controls.",
        "custom": "{{name}} (Custom)",
        "set": {
            "title": "It doesn't look like you have app controls set yet.",
            "description": "App Controls are how Cephable knows what to listen for and what actions to take. You can swap control app controls whenever you'd like from the homepage or by going to your connection settings.",
            "cta": "Set App Controls",
            "empty": {
                "auto": "Switch to another app to see controls",
                "select": "Select a control to begin",
                "none": "No app controls found"
            }
        },
        "summary": {
            "title": "App Controls Summary",
            "descriptionLong": "Here are the details of these app controls. You can search controls, actions, and more to see what you can do with these app controls.",
            "description": "Get a summary of these app controls including what controls there are, customizations, details, and more.",
            "view": "View App Controls Summary",
            "filter": "Filter by Input Type",
            "placeholder": "Search control names..."
        },
        "copy": {
            "title": "Copy App Controls",
            "duplicate": "Duplicate App Controls",
            "question": "Create a copy?",
            "description": "Want to create a new copy of these app controls? This will open a new window with these app controls copied but it won't be added to your account until you save it.",
            "confirm": "Yes, create a copy",
            "profileSuffix": "{{name}} (copy)"
        },
        "new": {
            "title": "Create New App Controls",
            "description": "Craft controls from the ground up or let cutting-edge AI generate personalized controls, empowering you to navigate apps and software effortlessly using your voice, head, and face gestures.",
            "note": "Recommended for advanced users.",
            "scratch": "Create from Scratch"
        },
        "advancedOptions": "Advanced Control Options",
        "delete": {
            "title": "Delete App Controls",
            "titleLong": "Delete these app controls",
            "description": "You can delete these app controls by clicking 'Delete App Controls'.",
            "confirm": "Are you sure you want to delete these app controls",
            "confirmLong": "Once you delete these app controls, you won't be able to return to it. Are you sure you want to delete these app controls?",
            "confirmButton": "Yes, delete these app controls"
        },
        "current": "Current Controls",
        "loading": "Loading controls...",
        "null": "You have no app controls yet. Click below to create one.",
        "nullButton": "Create your first app controls",
        "preview": "Preview",
        "features": "Features",
        "byline_public": "By: Cephable Team",
        "byline_shared": "Shared by: Cephable Community",
        "share": {
            "title": "Share App Controls",
            "previewTitle": "Shared App Controls Preview",
            "description": "Share these app controls with others so they can get a copy and personalize from there!",
            "descriptionLong": "Share these app controls with others so they can get a copy and personalize from there! Choose how you want to share, then create a link to send to others.",
            "add": "Create a Share Link",
            "confirm": "Share this url",
            "link": "Share Link",
            "copy": "Copy Link",
            "copied": "Copied!",
            "usage": "Usage Amount",
            "created": "Created {{value}}",
            "expiration": {
                "title": "Expiration",
                "once": "Only allow one use",
                "unlimited": "Allow unlimited usage",
                "no": "No expiration",
                "date": "Expiration Date",
                "dateDescription": "Expire at a specific date"
            },
            "manage": "Manage previous share links",
            "empty": "No shares have been created for these app controls."
        },
        "swap": {
            "title": "Swap Controls",
            "titleLong": "Swap your App Controls",
            "descriptionShort": "Use different app controls to match the program or software you are using.",
            "description": "You can swap between different app controls to match the program or software you are using."
        },
        "autoProfileSwitching": {
            "title": "Automatic Control Switching",
            "description": "Automatic control switching allows Cephable to adapt to your workflow seamlessly. When turned on, Cephable will contextually adjust your app controls based on the program or software you're using. If turned off, you can manually switch app controls using the 'Swap Controls' button or using global commands.",
            "alerts": {
                "disabled": "Automatic Control Switching is turned off.",
                "temporarilyDisabled": "Automatic Control Switching is temporarily turned off.",
                "enabled": "Automatic Control Switching is turned on.",
                "error": "Error saving automatic control switching preferences"
            },
            "associatedPrograms": {
                "add": "Add a New Associated Program",
                "description": {
                    "personal": "Choose the software or programs you want to connect to these controls. This supports Automatic Control Switching, where Cephable will automatically switch these app controls to match the current program you are using.",
                    "short": "Choose the software or programs you want to connect to these controls."
                },
                "edit": "Edit Associated Programs",
                "noOptionsText": "Begin typing to find associated programs",
                "profileLabel": "App Controls: ",
                "remove": "Remove Associated Program",
                "title": "Associated Programs",
                "when": "Cephable will automatically switch my app controls to {{profileName}} when I use...",
                "emptySearch": "There are no programs associated with these controls.",
                "error": "Error saving associated programs. Please try again later.",
                "emptyError": "Empty Associated Program detected, please remove before continuing."
            },
            "commandOverlay": {
                "command": "Switching App Controls: {{value}}"
            }
        },
        "error": {
            "noMatch": "No app controls match your search.",
            "save": "Error saving app controls. Please try again.",
            "conflicts": "Error saving app controls due to conflicts.",
            "load": "Error loading app controls.",
            "add": "Error adding app controls.",
            "delete": "Error deleting app controls.",
            "audioEventsWithEmptyCommands": "You have missing controls in your talk back. Check your talk back controls to make sure you fill it out completely.",
            "device": "Invalid app control for this connection. Please try a different one."
        },
        "conflictIndicators": {
            "errorTitle": "Error saving app controls due to conflicts",
            "warningTitle": "App controls saved with warnings",
            "subtitle": "The app controls you created has some configurations that may conflict.",
            "profileNameErrors": "App Controls name conflict",
            "emptyControlsMapped": "Empty input names",
            "emptyControlsMappedDescription": "Please add a voice command, facial expression, head tilt, or other command to your input.",
            "emptyKeybindingControlsMapped": "Empty input names for keybindings",
            "emptyKeybindingControlsMappedDescription": "Please add a voice command, facial expression, head tilt, or other command to your input for keybindings.",
            "duplicateNameTitle": "Duplicate App Controls name",
            "duplicateNameDescription": "You have a existing app controls with the same name. Please change the name before continuing.",
            "emptyNameTitle": "Empty app controls name",
            "emptyNameDescription": "The app controls must have a name for it. ie Game 1, Spotify, Word, etc.",
            "macrosReleaseKeysMissingTitle": "Outputs with unreleased keys",
            "macrosReleaseKeysMissingDescription": "Please add a release key or stop all step to prevent keys from getting stuck.",
            "duplicateInputCommandMacroTitle": "Identical control inputs",
            "duplicateCommandsDescription": "Please remove or change the duplicate input commands.",
            "duplicateInputCommandBindingsTitle": "Identical control inputs for keybindings",
            "conflictIndicatorDisplayString": "{{container}} : {{commandOrKeyName}} with {{commandOrEventType}}",
            "duplicateMacroNames": "Duplicate Control Names",
            "duplicateMacroNamesDescription": "Please remove or change one of your identical control names.",
            "warningIgnore": "Ignore",
            "warningDoNotShowAgain": "Do not show warnings again",
            "macrosVoiceCommandConflictWithDictationTitle": "Control voice commands same as dictation key words",
            "keybindingsVoiceCommandConflictWithDictationTitle": "Keybindings voice commands same as dictation key words",
            "macrosVoiceCommandConflictWithDictationDescription": "Your voice inputs will trigger dictation and voice commands.",
            "keybindingsVoiceCommandConflictWithDictationDescription": "Your voice inputs will trigger dictation and key presses.",
            "macrosVoiceCommandConflictWithGenerationTitle": "Control voice commands same as generation key words",
            "keybindingsVoiceCommandConflictWithGenerationTitle": "Keybindings voice commands same as generation key words",
            "macrosVoiceCommandConflictWithGenerationDescription": "Your voice inputs will trigger generation and voice commands.",
            "keybindingsVoiceCommandConflictWithGenerationDescription": "Your voice inputs will trigger generation and key presses.",
            "duplicateAssociatedProgramNames": "Duplicate associated program names",
            "duplicateAssociatedProgramNamesDescription": "Please remove or change one of your identical associated programs.",
            "emptyEvent": {
                "title": "Missing Steps",
                "description": "There are missing steps in your controls. This could lead to Cephable not doing an action when you give a command."
            },
            "warningDetails": "View all conflicts"
        },
        "success": {
            "save": "App controls saved.",
            "add": "App controls added.",
            "delete": "App controls deleted.",
            "share": "Share link created and copied to clipboard",
            "shareDelete": "Share link deleted.",
            "generate": "App controls generated."
        },
        "warning": "App controls saved with warnings"
    },
    "macros": {
        "title": "Control",
        "titlePlural": "Controls",
        "description": "Controls contain an input (action that you do like tilt your head) and steps that Cephable will do after that input action has been recorded. You can use controls to create a combination of steps that are triggered by a single input.",
        "new": "Create a New Control",
        "newDescription": "Create a new control to combine multiple steps and inputs.",
        "add": "Add Control",
        "create": "Create a Control",
        "name": {
            "title": "Control Name",
            "question": "What do you want to call this control?",
            "description": "Give your control a name so you can easily find it later.",
            "placeholder": "action this control is doing like \"jump\" or \"zoom in\""
        },
        "empty": "You have no controls yet. Click below to create one.",
        "copySuffix": "{{name}}_copy"
    },
    "event": {
        "title": "Step",
        "titlePlural": "Steps",
        "previewSummaryPlural": "{{first}} and {{total}} more events",
        "add": "Add Step",
        "stepType": "Step Type",
        "select": "Select the type of step you want to add.",
        "question": "What type of actions do you want Cephable to perform?",
        "setup": "Configure your Step",
        "description": "Steps are the actions that Cephable will do after the input has been triggered. You can add multiple steps to a control to create a combination of actions.",
        "expand": "Expand to see the rest of the steps",
        "stepUp": "Move Step Up",
        "stepDown": "Move Step Down",
        "stepCopy": "Copy Step",
        "stepRemove": "Remove Step",
        "insertStep": "Insert Step Below",
        "showOptions": "Show Options",
        "hideOptions": "Hide Options",
        "hold": "Hold time (in milliseconds)",
        "error": "You must configure your step.",
        "multiple": "Multiple Steps",
        "deviceTypeCustomAction": {
            "title": "Custom Device Action"
        },
        "keyPress": {
            "title": "Press Key or Button ",
            "short": "Press",
            "fieldSet": "Keys or Button to Press",
            "label": "Key or Button",
            "holdTime": "Hold key time (in milliseconds)",
            "description": "Press a keyboard key without using the keyboard.",
            "longDescription": "This function simulates the pressing of a key on your keyboard. For instance, if you have difficulty pressing physical keys, you can use a voice command or another input method to \"press\" a key virtually.",
            "example": "Say \"Enter\" to send an email without physically pressing the Enter key.",
            "timing": "Key Press Timing",
            "tap": "Tap",
            "tapLong": "Tap Button",
            "latch": "Latch",
            "latchLong": "Hold until released",
            "hold": "Hold",
            "holdLong": "Hold for amount of time",
            "toggle": "Toggle",
            "toggleLong": "Toggle action",
            "release": "Release",
            "releaseLong": "Release action",
            "latchLabel": "Hold <strong> {{value}} </strong> until released",
            "tapLabel": "Tap <strong> {{value}} </strong>",
            "pressLabel": "Press <strong> {{value}} </strong> for <strong> {{time}} </strong> milliseconds",
            "remove": "Remove Key Press",
            "add": "Add Key/Button to Press"
        },
        "keyRelease": {
            "title": "Release Key or Button",
            "short": "Release",
            "selected": "Selected Keys to Release",
            "description": "Let go of a keyboard key you've pressed and held.",
            "longDescription": "This function simulates the release of a key on your keyboard. It should be used in conjunction with a key press that is held indefinitely. For instance, if you have difficulty pressing physical keys, you can use a voice command or another input method to \"release\" a key virtually.",
            "example": "Say 'Stop' after saying 'Toggle Run' to stop running.",
            "label": "Release <strong> {{value}} </strong>",
            "add": "Add Key/Button to Release",
            "remove": "Remove Key Release"
        },
        "keyToggle": {
            "title": "Toggle Key or Button",
            "short": "Toggle",
            "selected": "Selected Keys to Toggle",
            "description": "Turn a keyboard key on or off like a light switch with a single control.",
            "longDescription": "This turns a key's function on or off, like a switch. It's useful for keys that you want to hold for an indeterminate amount of time. You can use this to keep the same action for both key press and key release or stop.",
            "example": "Say 'Toggle Run' to start running. Say 'Toggle Run' to stop running.",
            "label": "Toggle <strong> {{value}} </strong>",
            "add": "Add Key/Button to Toggle",
            "remove": "Remove Key Toggle"
        },
        "pause": {
            "title": "Pause",
            "description": "Add a brief delay between actions.",
            "longDescription": "This function allows you to insert a brief delay between actions, which is essential in situations where one action must fully complete before the next begins. For example, if you're using a command to make text bold in a document, you might first need to open a context menu. The Pause function gives enough time for the context menu to open and become active before proceeding to the next step, ensuring smooth and error-free operation.",
            "example": "Imagine you're editing a document using voice commands. You say \"Format text,\" which opens a context menu. Then, after a brief pause to allow the menu to fully appear, you say \"Bold\" to apply bold formatting to the selected text. The Pause function ensures the context menu is ready to receive your next command.",
            "label": "Pause for <strong> {{value}} </strong> milliseconds"
        },
        "type": {
            "title": "Type",
            "field": "Phrase to Type",
            "placeholder": "typed phrase",
            "question": "What text do you want to type?",
            "description": "Write out text like using a keyboard.",
            "longDescription": "This mimics typing a string of text, similar to typing on a keyboard. It's ideal for entering longer text without needing to press each key. If you want to dynamically enter text, you can use the Dictation function instead.",
            "example": "Say \"Name\" to type \"Hello, my name is Ellen Ripley.\" in a chat window.",
            "label": "Type <strong> {{value}} </strong>"
        },
        "mouseMove": {
            "title": "Move the Mouse",
            "description": "Move the pointer on the screen.",
            "longDescription": "Move your screen's cursor or pointer without a physical mouse. This is particularly helpful for users with limited hand mobility. This is useful for fine control of mouse movement that is needed in some games. If you want to simulate all mouse movement using your head movement, you can try the 'Head Movement for Mouse Control' in the camera settings.",
            "example": "Say \"Move Mouse Right\" to move the cursor to the right 100px.",
            "moveX": "Mouse Move Left/Right Pixels",
            "numberMoveX": "Number of pixels to Move Left/Right",
            "moveY": "Mouse Move Up/Down Pixels",
            "numberMoveY": "Number of pixels to Move Up/Down",
            "label": "Move the mouse <strong> {{value}} </strong>",
            "command": "Mouse Move: {{command}}"
        },
        "joystickMove": {
            "title": "Move Joysticks",
            "description": "Use a joystick to move things on the screen.",
            "longDescription": "This function simulates the movement of a joystick. For instance, if you have difficulty using a physical joystick, you can use a voice command or another input method to move a joystick virtually.",
            "example": "Say \"Move Joystick Left\" to move the joystick to the left 100px.",
            "prefix": "Move the left joystick",
            "left": "Left Joystick",
            "leftX": "Left X",
            "leftY": "Left Y",
            "right": "Right Joystick",
            "rightX": "Right X",
            "rightY": "Right Y",
            "x": "X Axis Strength",
            "y": "Y Axis Strength",
            "moveXLabel": "Move X: {{value}}",
            "moveYLabel": "Move Y: {{value}}",
            "labelLeft": "Move the Left joystick ",
            "labelRight": "Move the Right joystick ",
            "latch": "Latch will hold the position until you release using a 'Stop All' command."
        },
        "playAudio": {
            "title": "Play Audio",
            "placeholder": "phrase of statement that Cephable will say",
            "description": "Play a sound, word, or phrase.",
            "longDescription": "This function enables users to convert typed phrases into spoken words. It's especially useful for individuals who may have difficulty speaking. By typing in a phrase, the PlayAudio feature will articulate the text aloud using synthesized speech. This can assist in communication or in situations where a user needs to relay information verbally but prefers or requires an alternative to using their own voice.",
            "example": "Smile to play the word \"Hello\".",
            "label": "Speak <strong>\"{{value}}\"</strong>"
        },
        "stopOutputs": {
            "title": "Stop All Outputs",
            "titleLong": "Stop all outputs (release all keys and buttons, stop all mouse movements, stop all typing)",
            "description": "Stop all ongoing actions like key press.",
            "longDescription": "Immediately stop all ongoing outputs or actions. This is a safety or convenience feature to halt any process. We will automatically do this for you when you close, or pause the camera or microphone controls.",
            "example": "Say \"Stop\" to stop all outputs.",
            "label": "Stop all outputs and release keys"
        },
        "custom": {
            "title": "Custom"
        },
        "options": {
            "moveUp": "Move Up",
            "moveDown": "Move Down",
            "moveLeft": "Move Left",
            "moveRight": "Move Right",
            "copyStep": "Copy Step",
            "removeStep": "Remove Step"
        },
        "directions": {
            "up": "Up",
            "down": "Down",
            "left": "Left",
            "right": "Right"
        }
    },
    "expression": {
        "title": "Face Expression",
        "titlePlural": "Face Expressions",
        "label": "Expression / Gesture",
        "description": "Elevate your digital experience with facial expressions. Use gestures like eyebrow raises, smiles, and other movements to seamlessly control your mouse pointer, perform actions, or customize your interactions.",
        "start": "Start Expression Controls",
        "startSmiling": {
            "title": "Start Smiling",
            "description": "If you start not smiling and then start to smile, this control will trigger. Note: using this control in the same app controls as the Mouth Open / close control may cause conflicts."
        },
        "stopSmiling": {
            "title": "Stop Smilling",
            "description": "If you are smiling and then stop smiling, this control will trigger.  Note: using this control in the same app controls as the Mouth Open / close control may cause conflicts."
        },
        "eyebrows": {
            "title": "Raise Eyebrows",
            "description": "If you raise both your eyebrows from your baseline resting position, this control will trigger."
        },
        "openMouth": {
            "title": "Open Mouth",
            "description": "If your mouth is closed (or if your baseline is slightly open), and you open your mouth more, this control will trigger.  Note: using this control in the same app controls as the smile control may cause conflicts."
        },
        "closeMouth": {
            "title": "Close Mouth",
            "description": "If your mouth is open and you close it entirely, this control will trigger. Note: using this control in the same app controls as the smile control may cause conflicts."
        }
    },
    "head": {
        "title": "Head Movement",
        "titlePlural": "Head Movements",
        "label": "Head / Body Movement",
        "question": "What type of movement do you want to use?",
        "description": "Control your device or connection with head movements like tilting, nodding, or turning. Using your device's camera, Cephable ensures a private and intuitive experience for enhanced control or mouse navigation.",
        "tilt": {
            "title": "Head Tilt",
            "description": "Tilt your head to the left or right for enhanced control or mouse navigation.",
            "left": {
                "title": "Tilt Head Left",
                "description": "If you are looking at the camera and tilt your head to your left, this control will trigger."
            },
            "right": {
                "title": "Tilt Head Right",
                "description": "If you are looking at the camera and tilt your head to your right, this control will trigger."
            },
            "back": {
                "title": "Tilt Head Back",
                "description": "If you are looking at the camera and tilt your head back and look up, this control will trigger."
            },
            "forward": {
                "title": "Tilt Head Forward",
                "description": "If you are looking at the camera and tilt your head forward and look down, this control will trigger."
            }
        },
        "turn": {
            "title": "Head Turn",
            "description": "Turn your head to the left or right for enhanced control or mouse navigation.",
            "left": {
                "title": "Turn Head Left",
                "description": "If you are looking at the camera and turn your head and look to your left, this control will trigger."
            },
            "right": {
                "title": "Turn Head Right",
                "description": "If you are looking at the camera and turn your head and look to your right, this control will trigger."
            }
        },
        "lean": {
            "title": "Head Lean",
            "description": "Lean your head to the left or right for enhanced control or mouse navigation.",
            "left": {
                "title": "Lean Head Left",
                "description": "If you are looking at the camera and lean left so your face is further left in the camera frame, this control will trigger."
            },
            "right": {
                "title": "Lean Head Right",
                "description": "If you are looking at the camera and lean right so your face is further right in the camera frame, this control will trigger."
            },
            "back": {
                "title": "Lean Head Back",
                "description": "If you are looking at the camera and lean back so your face is further from the camera, this control will trigger."
            },
            "forward": {
                "title": "Lean Head Forward",
                "description": "If you are looking at the camera and lean forward so your face is closer to the camera, this control will trigger."
            },
            "up": {
                "title": "Move Body Up",
                "description": "If you are looking at the camera and move your head up by stretching your neck or moving your whole body up, this control will trigger."
            },
            "down": {
                "title": "Move Body Down",
                "description": "If you are looking at the camera and move your head down by scrunching your neck, ducking, or lowering your whole body, this control will trigger."
            },
            "center": {
                "title": "Center your Head",
                "description": "If you are looking at the camera and move your head back to the center position matching baseline, this control will trigger."
            }
        }
    },
    "voice": {
        "title": "Voice Control",
        "titlePlural": "Voice Controls",
        "placeholder": "Voice or phrase Cephable will listen for",
        "question": "What statement or phrase do you want to say for this control?",
        "when": "When I say...",
        "say": "Say '{{value}}'",
        "description": "Starting the microphone unlocks intelligent and natural voice commands, empowering users to seamlessly interact with their computer across applications and software. Speak naturally to execute commands or dictate text, creating an effortless and intuitive experience.",
        "load": {
            "fail": {
                "title": "{{language}} Voice Controls Unavailable",
                "description": "Oh no! We couldn't load {{language}} for voice controls. Please check your internet connection and try again. Using English (US) until connection is restored."
            }
        }
    },
    "hotkey": {
        "title": "Quick Action Button",
        "titlePlural": "Quick Action Buttons",
        "titlePanel": "Quick Actions",
        "label": "Quick Action Button Display Name",
        "placeholder": "Name to display",
        "question": "What would you like to name this button?",
        "when": "When I tap...",
        "description": "Quick Action Buttons are customizable buttons that you can tap to do relevant actions on your app. A single tap can run multiple steps or a single action.",
        "usagePrompt": "Quick Action Buttons are customizable buttons that you can tap to do relevant actions on your app. You can add, remove, or edit the names from the main app control settings page.",
        "reorder": "You can rearrange the order using the move up and down buttons.",
        "emptySearch": "There are no quick actions matching this criteria.",
        "empty": "It looks like you don't currently have any quick actions.",
        "emptyLong": "No quick action buttons are configured in these app controls. Once you add quick action buttons or choose app controls with one, they'll appear here.",
        "emptyTitle": "No Quick Action Buttons",
        "edit": "Edit Quick Action Buttons",
        "tap": "Tap {{value}}",
        "copySuffix": "{{name}}_copy",
        "hotkeysOnly": "Custom Buttons",
        "allControls": "All App Controls",
        "show": "Show Quick Action Buttons",
        "deprecatedDialog": {
            "title": "Your app controls requires an update.",
            "description1": "It looks like you're using older app controls with quick action buttons. We've got some exciting updates in\n            store for you! We've revamped the system to make creating and editing quick action buttons a breeze, no\n            more diving into advanced settings.",
            "description2": "Just a quick update is all it takes—literally a second—and you'll be enjoying the seamless button\n            customization experience. Say goodbye to the extra steps and hello to a more user-friendly\n            interface. Ready to make the switch?",
            "confirm": "Let's do it!"
        },
        "demo": {
            "title": "Demo Quick Action Buttons",
            "description": "The demo area below will allow you to try quick action buttons. The demo is limited to specifically controlling this text area below.",
            "step1": "Turn On Quick Action Buttons",
            "step2": "Use the example prompts below to control the text block.",
            "command1": "Press button 1 to “Make text larger”",
            "command2": "Press button 2 to “bold text”",
            "command3": "",
            "continue": "Continue with Quick Action Buttons"
        },
        "example": {
            "title": "Examples of Quick Action Buttons ",
            "description": "These examples showcase the versatility of Quick Action Buttons in controlling your device or connection. They can be used to execute commands, navigate interfaces, or perform actions with a simple tap.",
            "command1": "Tap Pause",
            "example1": "Example “pause video”",
            "command2": "Tap Forward",
            "example2": "Example “zoom out”",
            "command3": "Tap Stop",
            "example3": "Example “close window”"
        }
    },
    "motion": {
        "title": "Motion Control",
        "titlePlural": "Motion Controls",
        "question": "What type of motion with a phone or tablet do you want to use?",
        "start": "Start Motion Controls",
        "settings": "Motion Settings",
        "descriptionShort": "Tilt, turn, or shake your connection to control Cephable.",
        "description": "Motion controls let you turn your phone or tablet movement in the Companion App into controls for your connection. Tilt or shake your phone in different directions to create new outputs.",
        "up": {
            "title": "Tilt Your Device Up",
            "description": "If your device is flat on a surface and you tilt it up to face you, this control will trigger."
        },
        "down": {
            "title": "Tilt Your Device Down",
            "description": "If your device is flat on a surface and you tilt it down to face away from you, this control will trigger."
        },
        "left": {
            "title": "Tilt Your Device Left",
            "description": "If your device is flat on a surface and you tilt it left to face toward the left, this control will trigger."
        },
        "right": {
            "title": "Tilt Your Device Right",
            "description": "If your device is flat on a surface and you tilt it right to face toward the right, this control will trigger."
        },
        "shake": {
            "title": "Shake Your Device",
            "description": "If you shake your device, this control will trigger."
        },
        "edit": {
            "title": "Edit Motion Settings",
            "description": "Change your motion control settings to adjust how much you need to move your phone while running to Companion App",
            "sensitivity": {
                "title": "Motion Control Sensitivity Settings",
                "description": "Sensitivity tells Cephable how far you need to tilt your device in order to trigger a control. The larger the value (furthest right on the slider), the higher the sensitivity is, and therefore the less you need to tilt to trigger the control."
            },
            "tilt": {
                "title": "Tilt Sensitivity",
                "description": "These values determine how far you need to tilt your device up, down, left, and right for an input to be recognized."
            },
            "mouse": {
                "title": "Motion Controls for Mouse Movement",
                "description": "Determine if and how you want to use motion controls for moving your mouse instead of triggering controls",
                "enable": {
                    "title": "Enable Motion Controls for Mouse Movement",
                    "description": "If this is turned on, then some of your motion controls will be used to move your mouse instead of trigger controls.",
                    "option": "Use Motion Controls for Mouse Movement?"
                },
                "invert": {
                    "title": "Invert Mouse Movement",
                    "description": "For X-axis: If this is turned on, then moving left will move your mouse right and moving right will move it left. For Y-axis: If this is turned on, then moving down will move your mouse up and moving up will move it down.",
                    "x": "Invert X-axis Mouse Movement?",
                    "y": "Invert Y-axis Mouse Movement?"
                }
            }
        }
    },
    "keys": {
        "title": "Key or Button",
        "titlePlural": "Keys or Buttons",
        "label": "External Key / Button",
        "question": "What key or button do you want to press?",
        "edit": "Edit Keys and Buttons",
        "defaultOption": "Include default voice commands for keys and mouse clicks?",
        "description": "Keys and buttons allow you to map your different input controls to keyboard and controller button presses.",
        "then": "Cephable will press...",
        "empty": "There are no key controls matching this criteria.",
        "backspace": "Backspace",
        "delete": "Delete",
        "enter": "Enter",
        "space": "Space Bar",
        "tab": "Tab",
        "shift": "Shift",
        "ctrl": "Ctrl",
        "leftCtrl": "Left Ctrl",
        "rightCtrl": "Right Ctrl",
        "leftShift": "Left Shift",
        "rightShift": "Right Shift",
        "alt": "Alt",
        "leftAlt": "Left Alt",
        "escape": "Escape",
        "up": "Up Arrow",
        "down": "Down Arrow",
        "left": "Left Arrow",
        "right": "Right Arrow",
        "command": "Command",
        "caps": "Caps Lock",
        "reset": {
            "title": "Reset Keybindings",
            "confirm": "Reset all keybindings?",
            "confirmDescription": "Choose how you want to reset the keybindings. This action cannot be undone without saving.",
            "confirmButton": "Reset Keybindings",
            "defaultOption": "Reset to default values for the current language",
            "emptyOption": "Reset to empty (clear all commands)"
        }
    },
    "talkback": {
        "title": "Talkback",
        "question": "What do you want Cephable to say?",
        "description": "Setup controls that will have Cephable speak for you. You can assign controls to different phrases you want to be spoken.",
        "thenMacro": "then Cephable will say ...",
        "empty": "There are no talkback controls matching this criteria.",
        "deprecatedNotice": "Talkback is now integrated directly into the primary app controls. Your app controls has some older talkback events that need to be updated.",
        "add": "Add a New Talkback Control",
        "remove": "Remove Talkback Control",
        "edit": "Edit Talkback Controls"
    },
    "dictation": {
        "title": "Dictation",
        "question": "What phrase should trigger dictation mode?",
        "description": "Dictation lets you speak naturally and have your words typed while you talk. It's like having a personal assistant who types everything you say.",
        "thenMacro": "Cephable will...",
        "empty": "There are no dictation controls matching this criteria.",
        "type": "type",
        "edit": "Edit Dictation Phrases",
        "remove": "Remove Dictation Phrase",
        "add": "Add a New Dictation Phrase",
        "on": "Dictation",
        "off": "Commands",
        "onboarding": {
            "tourLabel": "Dictation",
            "learn": "Learn how to use dictation mode to convert your speech to text hands-free.",
            "welcome": {
                "title": "Dictation",
                "description": "Dictation lets you speak naturally and have your words typed while you talk. It's like having a personal assistant who types everything you say."
            },
            "microphone": {
                "title": "Turn on Your Microphone",
                "description": "First, turn on your microphone. Click the Microphone Toggle on the Cephable Panel."
            },
            "activate": {
                "title": "Start Dictation Mode",
                "description": "Voice starts in command mode. To start dictation, say \"Start dictation\" or click the Dictation button. Lets turn on dictation mode now."
            },
            "speaking": {
                "title": "Click a Document or Field and Start Speaking",
                "description": "Dictation will type out in real-time what you say. Click on a text field or document, then start speaking. For example, say: \"This is how to use dictation mode.\""
            },
            "pauseResume": {
                "title": "Pausing Dictation",
                "description": "Need a break without turning off dictation? Just say \"Pause dictation\". You can resume anytime with \"Start dictation.\" again. You can customize this further with your always on global and device controls."
            },
            "stop": {
                "title": "Stopping Dictation",
                "description": "Need to switch back to your app controls?  Just say \"Stop dictation\". This will stop dictation mode and return you to command mode. You can resume anytime with \"Start dictation.\" again."
            },
            "complete": {
                "title": "Congrats!",
                "description": "That's it! You can now dictate, pause, resume, and swap between dictation and command modes. Dictation is a powerful tool for hands-free typing. Use it to write emails, documents, or anything else you need to type out loud."
            }
        }
    },
    "suggestedPrompts": {
        "title": "Suggested Prompts",
        "description": "Customize suggested prompts that appear in AI tasks to help you get started quickly.",
        "edit": "Edit Suggested Prompts",
        "generate": "Generate Text",
        "rewrite": "Rewrite Text",
        "addGenerate": "Add a Generate Prompt",
        "addRewrite": "Add a Rewrite Prompt",
        "remove": "Remove Prompt",
        "generatePlaceholder": "Enter a prompt for text generation...",
        "rewritePlaceholder": "Enter a prompt for text rewriting...",
        "suggested": "Suggested prompts",
        "suggestedFor": "Suggested for {{profileName}}",
        "seeAll": "See all prompts",
        "showLess": "Show less",
        "allPrompts": "All Prompts",
        "customFor": "Custom prompts for {{profileName}}",
        "defaultPrompts": "Default prompts",
        "defaultGenerate": [
            "A professional email introducing our new product",
            "A meeting agenda for next week's team discussion",
            "A project proposal outline for a new initiative",
            "A formal business letter template",
            "A technical documentation section",
            "A user manual introduction",
            "A training document overview",
            "A policy document draft",
            "A follow-up email after a meeting",
            "A thank you message to a client",
            "A project status update email",
            "An invitation to a company event",
            "A reminder email for upcoming deadlines",
            "A welcome email for new team members",
            "An apology email for service interruption",
            "A newsletter introduction",
            "A brainstorming list for marketing campaigns",
            "Creative solutions for improving team productivity",
            "Ideas for a company retreat activities",
            "Concepts for a new mobile app feature",
            "Suggestions for improving customer experience",
            "Innovation ideas for our product development",
            "Content ideas for social media posts",
            "Workshop topics for professional development",
            "A function that validates user input",
            "A database query for user management",
            "Error handling code for API requests",
            "A configuration file template",
            "Comments explaining a complex algorithm",
            "Unit test cases for a new feature",
            "Documentation for API endpoints",
            "A script for automated deployment"
        ],
        "defaultRewrite": [
            "Make this text more concise and to the point",
            "Expand this summary with more detail",
            "Reformat this as a numbered list",
            "Convert this to bullet points",
            "Restructure this into clear paragraphs",
            "Make this text easier to scan quickly",
            "Organize this information hierarchically",
            "Format this as a step-by-step guide",
            "Make this message more professional and formal",
            "Rewrite this to sound more casual and friendly",
            "Adjust the tone to be more encouraging",
            "Make this sound more confident and assertive",
            "Soften the tone to be more diplomatic",
            "Add enthusiasm and energy to this text",
            "Make this more empathetic and understanding",
            "Rewrite with a more collaborative tone",
            "Simplify this for a general audience",
            "Make this explanation more technical and detailed",
            "Break down this complex concept into simpler terms",
            "Add more context and background information",
            "Summarize this into key takeaways",
            "Elaborate on the main points with examples",
            "Make this more accessible to beginners",
            "Condense this while keeping the essential information",
            "Improve the clarity and readability",
            "Make this more engaging and interesting",
            "Adjust for better grammar and flow",
            "Rewrite to emphasize the benefits"
        ]
    },
    "face": {
        "title": "Face Expression",
        "titlePlural": "Face Expressions",
        "try": "Try Face Expression Controls",
        "question": "What type of face expression do you want to use?",
        "descriptionShort": "Use different face movements for enhanced controls.",
        "description": "Face expressions are part of Expression Controls. It lets you use different face movements for enhanced controls. You can use eyebrow movement, mouth movement, and more to create different outputs."
    },
    "other": {
        "title": "Other",
        "titlePlural": "Other Controls",
        "label": "Other Control",
        "placeholder": "other experimental command",
        "question": "What additional command would you like to use? These are typically for non-Cephable connections that don't fit into other categories. They may also function as voice commands when you speak the specified word or phrase. Note: These controls are experimental and may not be fully supported.",
        "description": "Other controls are experimental and may not be fully supported. They can be used for non-Cephable connections or as voice commands when you speak the specified word or phrase."
    },
    "support": {
        "title": "Support",
        "question": "Still not finding what you need?",
        "more": "Learn more at Cephable.com with step-by-step guides, tutorials, videos, and more.",
        "profiles": "Introduction to App Controls"
    },
    "community": {
        "title": "Join the Community",
        "description": "Get support, share ideas, or become a member of Cephable's communities.",
        "discord": "Discord Community",
        "facebook": "Facebook Group"
    },
    "resources": {
        "title": "Helpful Resources",
        "description": "Find answers to your questions about Cephable features and functions.",
        "guides": "Step by Step Guides"
    },
    "feedback": {
        "title": "Feedback",
        "description": "Tell us about your experience with Cephable.",
        "contact": "Contact Us",
        "feature": "Suggest a Feature",
        "bug": "Report an Issue"
    },
    "settings": {
        "title": "Settings",
        "orgTitle": "{{ value }} Settings",
        "general": "General App Settings",
        "description": "This is your canvas for tailoring-your experience by fine-tuning your controls."
    },
    "account": {
        "title": "Account",
        "menu": "User Menu",
        "settings": "Account Settings",
        "description": "Update key information to stay connected with Cephable.",
        "usernameLabel": "Username: ",
        "emailLabel": "Email: ",
        "delete": {
            "title": "Delete Account",
            "description": "You can permanently delete your account and remove all reference to your personal information. When you delete your account, your connections will be removed, and will no longer work or be registered to your account, your app controls and all settings will be lost. This process can not be undone.",
            "button": "Permanently Delete Account",
            "confirmation": "Are you sure you want to delete your account?",
            "note": "This action is irreversible.",
            "confirm": "Yes, delete my account"
        },
        "password": {
            "change": "Change Password",
            "description": "Update your password to keep your account secure.",
            "old": "Old Password",
            "current": "Your current password",
            "new": "New Password",
            "desired": "Your desired new password",
            "confirm": "Confirm New Password",
            "update": "Update Password"
        },
        "isEmailVerified": {
            "title": "Email is not verified.",
            "titleAlt": "Verify your email address",
            "description": "Your email is not verified. Please check your email for a verification link.",
            "descriptionLong": "Welcome to Cephable! A verification email has been sent to {{email}}. Please check your inbox or spam folder and click on the link. If you don't see it, you can resend the verification email.",
            "org": "Your email is not verified. It is required to access license details. Please check your email for a verification link.",
            "resend": "Resend Email",
            "success": "We have sent you a new verification email.",
            "error": "There was an error sending the verification email. Please try again later.",
            "appBlock": "You're almost there! A verification email has been sent to {{email}}. Please check your inbox and click the link to verify your email address. If you don't see it, check your spam folder."
        },
        "signout": {
            "title": "Sign Out",
            "description": "Once you sign out, this connection will be removed from your account and no longer be visible from the Companion App or other connections.",
            "question": "Are you sure you want to sign out?",
            "confirm": "Yes, sign out",
            "confirmDescription": "Signing you out and removing this connection",
            "warn": {
                "title": "You’re about to be signed out.",
                "description": "It looks like you’ve been inactive for a while. For security reasons, we’ll sign you out in XX seconds. If you’d like to stay logged in, click “Stay Logged In” below.",
                "confirm": "Stay Logged In",
                "cancel": "Sign Out Now"
            }
        },
        "marketing": {
            "title": "Email Preferences",
            "description": "Update your email preferences to receive updates and news from Cephable.",
            "marketing": "Marketing Emails",
            "optIn": "I would like to receive tutorials, tips, updates and newsletters to enhance my Cephable experience"
        },
        "error": {
            "save": "Error saving account settings.",
            "password": "Error updating password.",
            "signout": "Error signing out.",
            "old": "Old password is required.",
            "new": "New password is required.",
            "match": "Passwords do not match.",
            "marketing": "Error updating email preferences.",
            "userPreferences": "Error saving user preferences."
        },
        "success": {
            "save": "Account settings saved.",
            "password": "Password updated.",
            "marketing": "Email preferences updated.",
            "userPreferences": "User preferences updated."
        },
        "userPreferences": {
            "title": "User Preferences",
            "description": "Update your preferences to create the Cephable experience that works for you.",
            "warningOptOut": "Hide warnings when I save or update app controls",
            "enableMetrics": "Enable usage metrics output for performance testing. You will be able to download the logs from the Cephable Panel.",
            "enableTranscribeTask": "Enable the experimental file transcriber task in the Cephable Panel",
            "enableGamepadSupport": "Enable gamepad support for local driver and Xbox controller emulation",
            "enableClickByName": "Windows ONLY. Enable experimental \"Tap\" something on the screen by name, such as \"tap save\" to click a button named \"save\""
        }
    },
    "license": {
        "titlePlural": "Licenses",
        "trial": {
            "title": {
                "single": "You've been upgraded to {{productName}} for free with {{days}} Days Remaining",
                "multiple": "{{organization}} is on a Free Trial with {{days}} Days Remaining"
            },
            "subtitle": "You can invite {{count}} colleagues to try Cephable with you. ",
            "noUsersSubtitle": "You have no trial users remaining. Upgrade to a paid license to add more users.",
            "upgrade": "By upgrading, maintain your access to features like enhanced voice controls, AI Intelligent Tasks, and many prebuilt app controls.",
            "expired": {
                "user": "Your free upgrade to {{productName}} expires on {{date}}. To upgrade, please contact your organization administrator - {{admin}}.",
                "userLong": "It looks like your free upgrade to {{productName}} has expired. To upgrade, please contact your organization administrator - {{admin}}.",
                "admin": "Your free upgrade to {{productName}} expires on {{date}}.",
                "adminLong": "It looks like your free upgrade to {{productName}} has expired. You can upgrade your license to continue accessing advanced features not available in Cephable Basic."
            },
            "start": "Start a Free Trial"
        },
        "key": {
            "title": "License Key",
            "titlePlural": "License Keys",
            "details": "License Key Details",
            "description": "A License Key is a unique identifier used to grant access to Cephable Professional, Education, or Developer features.",
            "assigned": "Used on: {{date}}",
            "expires": "Expires on: {{date}}",
            "assign": "Assign Key to New Organization",
            "error": "Error loading license key.",
            "empty": {
                "title": "No License Keys found.",
                "description": "It doesn't look like there are license keys matching this criteria. Or you have not purchased a license key yet."
            },
            "product": {
                "title": "Purchase",
                "titleLong": "Purchase License Keys",
                "description": "Purchase a license key to unlock the full potential of Cephable. View the different plans and pricing options available.",
                "action": "Purchase Now",
                "empty": {
                    "title": "No Products Found.",
                    "description": "It looks like you don't have any products. Please reach out to our sales team or your representative to help resolve this."
                },
                "yearly": "Billed yearly",
                "years": "Billed every {{value}} years",
                "days": "Billed every {{value}} days",
                "Subscription": {
                    "title": "Subscription"
                },
                "MeteredConsumption": {
                    "title": "Metered Consumption"
                },
                "PayDown": {
                    "title": "Pay Down"
                },
                "OneTime": {
                    "title": "One Time"
                }
            }
        },
        "upgrade": {
            "professional": "Upgrade to Cephable Professional License",
            "generic": {
                "title": "Upgrade your Cephable Experience",
                "description": "The Cephable Platform offers different products for commercial use at work, school, or integrated into native solutions."
            },
            "fallback": {
                "title": "Error Loading Billing Portal",
                "description": "Unable to load the billing portal. Please click the button below to contact sales@cephable.com to continue with the upgrade."
            }
        },
        "required": {
            "title": "Cephable Professional License is Required",
            "description": "It looks like you are using Cephable Basic which does not support the commercial use of Cephable. Please upgrade to a professional license to continue using the app."
        },
        "activate": {
            "question": "Already have a license key?",
            "button": "Activate",
            "title": "Activate License Key",
            "description": "Enter your license key to upgrade Cephable.",
            "descriptionLong": "Enter your license key to upgrade Cephable. If you don't have one, start a free trial or purchase a license.",
            "fieldLabel": "License Key",
            "placeholder": "NkmurBfZzFrmm9Kx",
            "invalid": {
                "empty": {
                    "key": "Invalid key. Please make sure you have entered a value.",
                    "name": "Invalid Organization Name. Please make sure you have entered a value."
                },
                "key": "Invalid key. Please make sure you have entered the correct key."
            },
            "success": "Congrats. Your account has been upgraded to {{license}}!"
        },
        "welcome": {
            "title": "Welcome to {{license}}.",
            "description": "You have successfully joined {{organization}}. {{description}}"
        },
        "redirect": {
            "title": "Redirecting",
            "description": "You have been redirected to an external billing portal. This will open a new tab in your browser. If you are not redirected within a few seconds, please click the button below.",
            "error": "Billing Redirect Error",
            "external": "Redirected. Please check your browser."
        },
        "pro": {
            "tag": "Pro",
            "detail": "This is a Cephable Professional only feature",
            "requiredDetail": "A Cephable Professional License is required for this feature. You can upgrade or start a free trial in your Account Settings"
        }
    },
    "publicProfiles": {
        "toolbar": "Explore App Controls",
        "title": "Explore App Controls",
        "description": {
            "personal": "Public app controls are available to help you quickly get started with Cephable on your favorite apps. You can use the default controls, customize them to your needs, or create entirely new custom app controls from scratch.",
            "pro": "Public app controls are available to help you quickly get started with Cephable on your favorite apps. You can use the default controls, customize them to your needs, or create entirely new custom app controls through the control generator."
        },
        "offline": {
            "title": "Unable to Load Public App Controls",
            "description": "It looks like you are offline. You can still use your app controls, but you will not be able to load new public app controls.",
            "confirm": "Okay"
        },
        "announcement": "{{count}} New App Controls have been loaded",
        "team": "Cephable Team"
    },
    "device": {
        "title": "Connection",
        "titlePlural": "Connections",
        "titleShort": "Connect",
        "titleLong": "Connections & Extensions",
        "description": "Cephable supports multiple devices and connections. You can manage settings or select any of them all from here. You will always have this computer as your main connection. You can add more connections later.",
        "viewAll": "View All Connections",
        "new": "You have a new connection!",
        "newLong": "You have a new connection! To start using it, select it from the menu below.",
        "add": {
            "short": "Extend",
            "title": "Add a New Connection or Extension",
            "description": "Connections and extensions are additional ways you can enhance your Cephable experience. You can add new connections to connect to more devices, applications, or games. Take your Cephable experience to the next level by adding connections and extensions.",
            "action": "Add a New Connection",
            "notAvailable": "This connection or extension is not currently available to the public. This often occurs when working with user generated extensions. Please check back later.",
            "isNotPublic": "PREVIEW: This extension is in developer preview and may be incomplete. Developers should complete all steps before public release. Users can check back later for the full version."
        },
        "swap": {
            "titlePlural": "Swap Connections"
        },
        "status": {
            "title": "Connection Status: ",
            "connected": {
                "application": "Connected Application",
                "connection": "Connected",
                "device": "Connected Device",
                "game": "Connected Game"
            },
            "disconnected": {
                "application": "Disconnected Application",
                "connection": "Disconnected",
                "device": "Disconnected Device",
                "game": "Disconnected Game"
            }
        },
        "control": {
            "button": "Control {{name}}",
            "generic": "Control Connection",
            "description": {
                "application": "Control this connected application using your voice, quick actions, head movements, and more. For instance, if you say 'Save' this will save on your running application.",
                "connection": "Control this connected connection using your voice, quick actions, head movements, and more. For instance, if you say 'Save' this will save on your running connection.",
                "device": "Control this connected device using your voice, quick actions, head movements, and more. For instance, if you say 'Open Spotify' this will open Spotify on running device.",
                "game": "Control this connected game using your voice, quick actions, head movements, and more. For instance, if you say 'Go' this will make the player move in running game."
            }
        },
        "running": "Running",
        "offline": "Offline",
        "otherDevices": "Other Output Connections",
        "currentStatus": "Current Status: ",
        "connectionStatus": "Connection Status: ",
        "profileStatus": "Current App Controls: ",
        "name": {
            "title": "Connection Name",
            "question": "What do you want to call this connection?",
            "description": "Give your connection a name so you can easily find it later.",
            "placeholder": "connection name",
            "edit": "Edit Connection Name"
        },
        "updates": {
            "title": "Connection Updates",
            "settings": "Connection Update Settings",
            "description": "Check for connection firmware updates and change auto-update settings",
            "edit": "Edit Update Settings",
            "check": {
                "title": "Check for Updates",
                "processing": "Checking for updates! It may take a few minutes and your connection may restart during updates.",
                "description": "Tap to check for updates for your connection. If there is an update available and your connection is active, it will start updating. Updates can take a few minutes."
            },
            "auto": {
                "title": "Automatically Update",
                "description": "With this setting turned on, your connection will automatically update whenever it is plugged in, connected to wi-fi, and an update is available. If this is off, you need to tap the update button to get the latest.",
                "option": "Use Auto-Update?"
            }
        },
        "delete": {
            "title": "Unlink {{name}}",
            "titleLong": "Unlink From Account",
            "description": "Unlinking disconnects Cephable from this computer or game and removes it from your account. You will no longer be able to connect to it, send commands, or update it. This can not be undone but you can create a new connection to the same computer or game if you want to use it again in the future.",
            "confirm": "Are you sure you want to unlink this connection?",
            "confirmLong": "Are you sure you want to deregister and reset this connection? You will no longer be able to connect to it, send commands, or update it. After this de-register and reset, anyone else can setup this connection from scratch.",
            "confirmButton": "Yes, remove this connection."
        },
        "manage": {
            "title": "Click to view and manage details for your connections.",
            "description": "",
            "name": "Customize your connection name for easier management."
        },
        "error": {
            "save": "Error saving connection.",
            "load": "Error loading connection.",
            "add": "Error adding connection.",
            "delete": "Error deleting connection.",
            "updates": "Error checking for updates.",
            "connection": "Connection is not established. Make sure it is connected before trying again.",
            "deleteLong": "We were unable to delete this connection from your account. If you log in again to this account, you may need to manually delete this connection in the connection settings."
        },
        "success": {
            "save": "Connection saved.",
            "add": "Connection added.",
            "delete": "Connection deleted."
        }
    },
    "appSettings": {
        "title": "General App Settings",
        "description": "These settings only apply to this app. If you want to change the settings of the Cephable app on another computer or mobile device, edit the settings in that app.",
        "autostart": {
            "title": "Automatically Start Cephable",
            "description": "With this setting turned on, the Cephable app will automatically start when you log in to your device. If you also have automatic voice and expression controls, those will also start right away.",
            "question": "Autostart Cephable App?"
        },
        "overlay": {
            "title": "Command Feed",
            "description": "The command feed will show the different controls you use and what controls were sent to your computer. It is click-through but will always be on top of other windows. With this setting turned on, the Cephable app will show and will always be on top of other windows and applications.",
            "question": "Show Command Feed?"
        },
        "position": {
            "label": "Select Command Feed Position",
            "description": "Select where you want the command feed to appear on your screen.",
            "topLeft": "Top Left",
            "top": "Top Center",
            "topRight": "Top Right",
            "bottom": "Bottom Center",
            "bottomLeft": "Bottom Left",
            "bottomRight": "Bottom Right"
        },
        "panelAutoHide": {
            "title": "Auto-Hide Cephable Panel",
            "delay": "Delay before hiding",
            "denominator": " seconds",
            "time": "{{value}} seconds"
        },
        "transparent": {
            "title": "Command Feed Transparency",
            "description": "The determines the opacity of the text. The lower the value, the more see-through the feed will be."
        },
        "micPosition": {
            "title": "Microphone Input Window Position",
            "description": "Select where you want the microphone controls for voice and dictation to be positioned on your screen.",
            "label": "Select Microphone Input Window Position"
        },
        "cameraPosition": {
            "title": "Camera Input Window Position",
            "description": "Select where you want the camera controls for face and head movement to be positioned on your screen.",
            "label": "Select Camera Input Window Position"
        },
        "theme": {
            "title": "Theme",
            "description": "Choose a theme that suits your style.",
            "label": "Select a Theme",
            "light": "Light",
            "dark": "Dark",
            "system": "Use OS System settings"
        }
    },
    "shortcuts": {
        "title": "Global Shortcuts",
        "description": "Customize keyboard shortcuts for quick access to Cephable controls from anywhere on your system.",
        "info": "These shortcuts work globally and can be used even when Cephable is not the active window.",
        "shortcut": "Shortcut",
        "toggleMicrophone": "Toggle Microphone",
        "toggleDictation": "Toggle Dictation Mode",
        "toggleVoiceControl": "Toggle Voice Control Mode",
        "togglePanel": "Toggle Panel",
        "registrationFailed": "Some global shortcuts failed to register. They may be in use by another application:",
        "record": {
            "title": "Record Shortcut",
            "start": "Click to Record",
            "listening": "Press your desired key combination...",
            "pressKeys": "Press keys now"
        },
        "formatHint": "Select at least one modifier key ({{modifierKey}}, {{modifierKey2}}, Shift) and one other key."
    },
    "input": {
        "title": "Input",
        "titlePlural": "Input Controls",
        "explore": "Explore Input Controls",
        "descriptionShort": "Explore the various input controls Cephable utilizes to create a better digital experience for you.",
        "description": "Input controls are the different methods used to control your device. Such as your voice, head movement, face expressions, and additional connections. Explore the different input controls below to learn more.",
        "typeLabel": "Input Control Type",
        "toolTip": "This uses {{alt}}",
        "remove": "Remove Input Control",
        "filter": "Filter by Input Type",
        "select": "Select an Input",
        "question": "What type of input do you want to use?",
        "add": "Add Input",
        "addMore": "Add another input",
        "removeItem": "Remove item {{index}}",
        "item": "Item {{index}}: {{label}}",
        "duplicate": "Duplicate items are not allowed.",
        "maximum": "Maximum of {{maxItems}} items allowed."
    },
    "time": {
        "soon": "Coming Soon",
        "now": "Now",
        "today": "Today",
        "yesterday": "Yesterday",
        "minutesAgo": "{{count}} minute ago",
        "minutesAgo_plural": "{{count}} minutes ago",
        "daysAgo": "{{count}} days ago",
        "daysAgo_plural": "{{count}} days ago",
        "monthsAgo": "{{count}} month ago",
        "monthsAgo_plural": "{{count}} months ago",
        "yearsAgo": "{{count}} year ago",
        "yearsAgo_plural": "{{count}} years ago",
        "minutesAhead": "in {{count}} minutes",
        "todayAhead": "later today",
        "tomorrow": "tomorrow",
        "daysAhead": "in {{count}} days",
        "monthsAhead": "in {{count}} months",
        "yearsAhead": "in {{count}} years"
    },
    "peripherals": {
        "empty": "No Peripherals Detected",
        "switch": "Switch",
        "keyboard": "Keyboard",
        "gamepad": "Gamepad",
        "companionApp": "Companion App",
        "available": "Available to use",
        "error": "Check your settings."
    },
    "textGeneration": {
        "settings": "Text Generation Settings",
        "edit": {
            "title": "Edit Text Generation Settings",
            "description": "Cephable's intelligent text generation feature allows you to use the \"generate\" device control to create text in any app. You can generate emails, paragraphs, messages, code, and more. It will generate the text wherever your cursor is as if you were typing it yourself. This feature uses on-device generative AI, which means your content never leaves your machine but that you should check content for accuracy. Use these settings to edit your preferences for how Cephable loads AI models on your device and how it generates text for you.",
            "autoStart": {
                "title": "Automatically Warm Up Text Generation",
                "description": "With this setting turned on, Cephable AI will automatically warm up the AI models used for text generation. Warming up the models will make them perform faster when you use generate commands, but will consume more resources on your computer. Turning this setting off will save resources, but may make text generation slower.",
                "option": "Auto warm up text-generation AI models?"
            },
            "enableTextGen": {
                "title": "Enable Intelligent Text Generation",
                "description": "With this setting turned on, Cephable AI will can use the text generation device control to generate text in any app for you. Turning this off will disable this command.",
                "option": "Use Intelligent Text Generation?"
            },
            "enableHistory": {
                "title": "Enable Text Generation History",
                "description": "With this setting turned on, Cephable AI will use your text generation history to generate text with context of your previous action.",
                "option": "Use Text Generaton History?"
            },
            "prompt": {
                "title": "Additional Information for Text Generation",
                "description": "Enter additional details to be used with Cephable's AI to generate text. Use this field to enter preferences for your tone, style of writing, or any other details.",
                "field": "Additional prompt",
                "placeholder": "e.g. Use a friendly tone, write like a professional, be succint and to the point. When writing code, leave thoughtful comments but not too many, etc."
            },
            "terminate": {
                "title": "Clear Text Generation Resources",
                "description": "Click to clear the resources used for text generation. This will free up resources on your computer, but may make text generation slower the next time you use it.",
                "button": "Clear Resources",
                "success": "Clearing text generation resources.",
                "confirm": {
                    "title": "Clear Text Generation Resources",
                    "description": "Are you sure you want to clear the resources used for text generation? This will free up resources on your computer, but may make text generation slower the next time you use it.",
                    "confirm": "Yes, clear resources",
                    "cancel": "Cancel"
                }
            },
            "clearModelCache": {
                "title": "Clear AI Model Cache",
                "description": "Select which AI model cache to clear and re-download. This will free up storage on your computer and re-download the selected model files.",
                "button": "Clear and Re-download",
                "success": "Deleted local model files.",
                "error": "Error deleting local model files.",
                "confirm": {
                    "title": "Clear and Re-download AI Model Cache",
                    "description": "Are you sure you want to clear the selected AI model cache and delete the files from your system? The selected models will be re-downloaded automatically.",
                    "confirm": "Yes, clear and re-download",
                    "cancel": "Cancel",
                    "textGenLabel": "Intelligent Tasks model",
                    "workflowsLabel": "AI Workflows models"
                }
            }
        },
        "prompt": {
            "systemPrompt": "Generate ONLY the requested text—no explanations, commentary, or fluff. No unprompted markdown or explanation. For code, output raw code only: no fences, no language tags, no explanation.",
            "appName": "You are currently generating text for {{appName}}.",
            "userPreferences": "Respect these user preferences for how they want text generated: {{userPreferences}}."
        },
        "summarizePrompt": {
            "systemPrompt": "Summarize the provided text concisely. It may be part of a larger document. Output ONLY the summary—no preamble, labels, or explanation.",
            "userPreferences": "Respect these user preferences for how they want text generated: {{userPreferences}}.",
            "userPrompt": "Summarize: {{userRequestText}}"
        },
        "rewritePrompt": {
            "systemPrompt": "Rewrite or reformat the provided text as instructed. If reformatting (e.g. lists, tables, structure changes), preserve the original words exactly. If rewriting (e.g. tone, style, length), preserve the meaning but not necessarily the words. Output ONLY the result—no explanations or commentary. This may be part of a larger document. Output only the result with no headings, labels, or preamble.",
            "userPreferences": "Respect these user preferences for how they want text generated: {{userPreferences}}.",
            "rewriteInstructions": "Instructions: {{rewriteInstructions}}."
        },
        "translatePrompt": {
            "systemPrompt": "Translate the following text into {{language}}. Output ONLY the translated text. No explanations, no preamble, no markdown formatting, no code fences. Retain formatting. For code: translate comments and strings only, preserve syntax exactly.",
            "userPreferences": "Respect these user preferences for how they want text generated: {{userPreferences}}.",
            "genericUserPrompt": "Translate: {{userRequestText}}"
        },
        "disabled": {
            "title": "Intelligent Tasks is Disabled",
            "description": "It looks like you have disabled intelligent tasks. Update to unlock text generation, rewriting, and more in your settings."
        }
    },
    "aiWorkflows": {
        "settings": {
            "title": "AI Workflows Settings",
            "description": "Configure the AI models and devices used for AI Workflows. AI Workflows allow you to automate desktop and browser tasks using on-device AI.",
            "configType": {
                "title": "Model Configuration Type",
                "description": "Select the type of model configuration to use for AI Workflows. Different configurations are optimized for different models.",
                "label": "Configuration Type"
            },
            "reasoningModel": {
                "title": "Reasoning Model",
                "description": "Select the AI model to use for reasoning and planning tasks. The reasoning model analyzes your requests and creates action plans.",
                "label": "Reasoning Model"
            },
            "reasoningDevice": {
                "label": "Reasoning Device"
            },
            "generationModel": {
                "title": "Generation Model",
                "description": "Select the AI model to use for text generation tasks. The generation model creates text content when needed by workflows.",
                "label": "Generation Model"
            },
            "generationDevice": {
                "label": "Generation Device"
            },
            "noModelsFound": "No models found",
            "autoWarm": {
                "title": "Auto-Start AI Workflows",
                "description": "Automatically initialize AI Workflow models when the app starts. Models will be pre-loaded so workflows can start immediately.",
                "option": "Auto-start AI Workflow models on app launch"
            },
            "prompt": {
                "title": "Additional Information for AI Workflows",
                "description": "Enter additional details to be used with Cephable's AI when running workflows. Use this field to enter preferences for your tone, behavior, or any other details.",
                "field": "Additional prompt",
                "placeholder": "e.g. Always confirm before sending emails. Prefer concise responses. Use formal language in documents."
            },
            "terminate": {
                "title": "Clear Workflow Resources",
                "description": "Click to terminate the workflow worker and free up resources. This will stop any running workflow and release memory used by the AI models.",
                "button": "Terminate Workflow Worker",
                "success": "Workflow worker terminated.",
                "confirm": {
                    "title": "Terminate Workflow Worker",
                    "description": "Are you sure you want to terminate the workflow worker? This will stop any running workflow and free up resources.",
                    "confirm": "Yes, terminate"
                }
            },
            "disableButtonNames": {
                "edit": "Block Button Interactions",
                "description": "Control which buttons AI Workflows are allowed to interact with. By default, Cephable can click any button on your screen. Use this setting to prevent accidental actions (for example, \"buy\", \"delete\").",
                "input": {
                    "label": "Button Name",
                    "question": "Which buttons would you like to block? You can enter full or partial button names.",
                    "remove": "Remove Button Name"
                },
                "button": "Block Buttons"
            }
        }
    },
    "camera": {
        "windowTitle": "Cephable Camera Controls",
        "title": "Camera",
        "titlePlural": "Cameras",
        "settings": "Camera Settings",
        "start": "Start Camera",
        "stop": "Stop Camera",
        "restart": "Restart Camera",
        "show": "Show Camera",
        "hide": "Hide Camera",
        "descriptionShort": "Enables face expression and head movement.",
        "description": "Use your camera to detect face expressions and body gestures as different controls.",
        "select": "Select a camera you want to pair with for enhanced controls using your face and body.",
        "empty": "No cameras found.",
        "search": "Search by camera name",
        "loading": "Loading Camera Controls...",
        "error": "Unexpected error loading camera controls. Please check your camera and try again.",
        "manage": {
            "title": "Click to view and manage details for your cameras.",
            "description": ""
        },
        "warn": "Camera controls have not been started, start your camera to allow face and body controls.",
        "detected": {
            "face": "Face Detected.",
            "noFace": "No Face Detected. Please adjust your camera or position and try again.",
            "command": "Detected: {{command}}"
        },
        "permission": {
            "title": "Camera Permissions Required",
            "description": "You need to give Cephable permission to use your camera to use face and body controls.",
            "button": "Open Permission Settings",
            "no": "No camera access",
            "help": "Cephable needs access to your camera to use expression and head controls. Navigate to <strong>System Settings</strong> > <strong>Privacy</strong> > <strong>Camera</strong> and enable Cephable to access your camera."
        },
        "controls": {
            "startData": "Started recording face data. Press the shortcut again while in camera window to stop recording and download.",
            "downloadData": "Stopped recording, downloading data",
            "paused": "Paused camera controls.",
            "pause": "Pause Camera Controls",
            "resume": "Resume Camera Controls",
            "resumed": "Resumed camera controls.",
            "linesOn": "Turn face lines on",
            "linesOff": "Turn face lines off",
            "lines": "Face Lines",
            "linesToggle": "Toggle draw face lines",
            "noDeviceTitle": "No camera detected that can be used with Cephable.",
            "noDeviceDescription": "You need to connect a camera that is compatible mobile apps.",
            "noDeviceConnectedDescription": "The camera control serves as a preview of the interface. No steps will be successfully executed. Connect this companion device to another, in order to initiate commands."
        },
        "draw": {
            "error": "Error loading camera feed. Please check your camera and try again."
        },
        "switch": {
            "title": "Switch Camera",
            "description": "Select a different camera to use for face and body controls.",
            "select": "Select Camera",
            "next": "Next Camera",
            "nextLong": "Switch to the next camera",
            "empty": "No other cameras found.",
            "search": "Search by camera name"
        },
        "baseline": {
            "title": "Baseline",
            "description": "The baseline is the default position of your face and body that Cephable uses to determine your movements. You can update and reset the baseline here.",
            "update": "Update Baseline",
            "reset": "Reset Baseline",
            "updated": "Baseline Updated",
            "tooltip": "Click to update your baseline to your current resting position."
        },
        "edit": {
            "title": "Edit Camera Settings",
            "description": "You can refine the settings for your inputs that require a camera to better suit your needs.",
            "autoStart": {
                "title": "Automatically Start Camera",
                "description": "With this setting turned on, your controller will start your camera enabling you to use face expressions and head movement controls right when the app starts. If this is off, you need to tap the \"Start Camera\" button in your connection page.",
                "option": "Autostart Camera and Head/Expression Controls?"
            },
            "head": {
                "title": "Head Movement Sensitivity",
                "description": "Sensitivity tells Cephable how far you need to move in order to trigger a control. The larger the value (furthest right on the slider), the higher the sensitivity is, and therefore the less you need to move to trigger the control.",
                "tilt": {
                    "title": "Head Tilt Sensitivity",
                    "description": "These values determine how far you need to tilt your head up, down, left, and right to trigger controls",
                    "up": "Tilt Up Sensitivity",
                    "down": "Tilt Down Sensitivity",
                    "left": "Tilt Left Sensitivity",
                    "right": "Tilt Right Sensitivity",
                    "scaleHigh": "Slight Tilt",
                    "scaleLow": "Large Tilt"
                },
                "turn": {
                    "title": "Head Turn Sensitivity",
                    "description": "These values determine how far you need to turn your head left and right to trigger controls",
                    "left": "Turn Left Sensitivity",
                    "right": "Turn Right Sensitivity",
                    "scaleHigh": "Slight Turn",
                    "scaleLow": "Large Turn"
                },
                "lean": {
                    "title": "Head Lean Sensitivity",
                    "description": "These values determine how far you need to lean your head forward and back to trigger controls",
                    "forward": "Lean Forward Sensitivity",
                    "back": "Lean Back Sensitivity",
                    "right": "Lean Right Sensitivity",
                    "left": "Lean Left Sensitivity",
                    "scaleHigh": "Slight Lean",
                    "scaleLow": "Large Lean"
                },
                "duck": {
                    "title": "Head Duck/Rise Sensitivity",
                    "description": "These values determine how far you need to duck or rise your head to trigger controls",
                    "down": "Duck Down Sensitivity",
                    "up": "Rise Up Sensitivity",
                    "scaleHigh": "Slight Shift",
                    "scaleLow": "Large Shift"
                }
            },
            "face": {
                "title": "Face Expression Sensitivity",
                "description": "Sensitivity tells Cephable how exaggerated of an expression you need to trigger a control. The larger the value (furthest right on the slider), the higher the sensitivity is, and therefore the less you need to move to trigger the control.",
                "eyebrow": {
                    "title": "Eyebrow Sensitivity",
                    "description": "These values determine how far you need to raise or lower your eyebrows to trigger controls",
                    "up": "Raise Eyebrow Sensitivity",
                    "scaleHigh": "Slight Raise",
                    "scaleLow": "Large Raise"
                },
                "mouth": {
                    "title": "Mouth Sensitivity",
                    "description": "These values determine how far you need to open or close your mouth to trigger controls",
                    "open": "Open Mouth Sensitivity",
                    "close": "Close Mouth Sensitivity",
                    "smile": "Smile Sensitivity",
                    "scaleHigh": "Slight Open",
                    "scaleLow": "Large Open",
                    "closeScaleHigh": "Slight Closed",
                    "closeScaleLow": "Tightly Closed",
                    "smileScaleHigh": "Slight Smile",
                    "smileScaleLow": "Large Smile"
                }
            },
            "mouse": {
                "title": "Head Movement for Mouse Controls",
                "disabled": "This feature is disabled for remote connections and extensions.",
                "description": "Determine if and how you want to use head movements controls to move your mouse instead of triggering other outputs.",
                "enable": {
                    "title": "Enable Head Movement for Mouse Controls",
                    "description": "If this is turned on, then some of your head movement controls will be used to move your mouse instead of trigger controls.",
                    "option": "Use Head Controls for Mouse Movement?"
                },
                "input": {
                    "title": "Mouse Input Type",
                    "description": "Select which type of head gestures you want to assign to mouse controls. For example, Head Tilting means you can tilt your head left and right to move your mouse left and right, Head Turning means you can turn your head left and right to move your mouse, and Head Leaning means you can lean left and right to move your mouse.",
                    "option": "Select Input Type",
                    "optionLong": "Select the type of head movement you want to use to control your mouse."
                },
                "invert": {
                    "title": "Invert Mouse Movement",
                    "description": "If this is turned on, then the direction you move your head will be inverted from the direction your mouse moves. For X-axis: If this is turned on, then moving left will move your mouse right and moving right will move it left. For Y-axis: If this is turned on, then moving down will move your mouse up and moving up will move it down.",
                    "x": "Invert X-axis Mouse Movement?",
                    "y": "Invert Y-axis Mouse Movement?"
                },
                "mode": {
                    "title": "Mouse Move Mode",
                    "description": "Select how you want the cursor to react to your head movements."
                },
                "speed": {
                    "title": "Mouse Speed",
                    "description": "Determine the constant speed you want the cursor move.",
                    "fast": "Fast",
                    "slow": "Slow"
                },
                "linear": {
                    "title": "Linear Mouse Movement",
                    "description": "If this is turned on, the cursor only moves in straight horizontal or vertical lines, making it easier to navigate in those specific directions without any diagonal drift.",
                    "option": "Use Linear Mouse Movement?"
                },
                "accelerationRate": {
                    "title": "Mouse Acceleration Response Delay",
                    "description": "The number of milliseconds it takes for the mouse speed to increase."
                },
                "accelerationCurve": {
                    "title": "Mouse Acceleration Curve",
                    "description": "Adjust the rate at which the cursor speed increases relative to head movement. ",
                    "linear": "Linear",
                    "exponential": "Exponential",
                    "sublinear": "Sub-linear"
                },
                "maximumSpeed": {
                    "title": "Maximum Mouse Speed",
                    "description": "Determine maximum number of pixels the cursor can move per second."
                },
                "off": {
                    "title": "Off",
                    "description": "Mouse movement is disabled."
                },
                "steadyGlide": {
                    "title": "Steady Glide",
                    "description": "When you move your head past a certain point, the cursor glides continuously in that direction at a steady speed."
                },
                "speedBoost": {
                    "title": "Speed Boost",
                    "description": "The cursor starts to move faster the longer you keep your head in one position. The longer you hold your head still, the quicker the cursor accelerates."
                },
                "dynamicGlide": {
                    "title": "Dynamic Glide",
                    "description": "The cursor's speed increases based on how far you move your head. The further you move your head, the faster the cursor glides."
                },
                "proportionalSpeed": {
                    "title": "Proportional Speed",
                    "description": "The cursor follows your nose tip proportional to your screen dimensions."
                }
            }
        }
    },
    "microphone": {
        "windowTitle": "Cephable Voice Controls",
        "title": "Microphone",
        "titlePlural": "Microphones",
        "settings": "Microphone Settings",
        "start": "Start Microphone",
        "startDescription": "Turn on the microphone to start listening to commands.",
        "stop": "Stop Microphone",
        "descriptionShort": "Enables voice commands and dictation.",
        "description": "Use your built in microphone to enable voice controls and dictation.",
        "select": "Select a microphone you want to pair with for enhanced controls using your voice.",
        "empty": "No microphones found.",
        "search": "Search by microphone name",
        "manage": {
            "title": "Click to view and manage details for your microphones.",
            "description": ""
        },
        "warn": "You microphone has not been started. Start the microphone to allow voice commands and dictation.",
        "permission": {
            "title": "Microphone Permissions Required",
            "description": "You need to give Cephable permission to use your microphone to use voice controls.",
            "button": "Open Permission Settings",
            "no": "No microphone access",
            "help": "Cephable needs access to your microphone to use voice controls. Navigate to <strong>System Settings</strong> > <strong>Privacy</strong> > <strong>Microphone</strong> and enable Cephable to access your microphone."
        },
        "controls": {
            "loadingDetail": "This may take a few minutes.",
            "generatingTextDetail": "Stop generation by changing apps or saying 'stop generating'",
            "pause": "Pause Voice Controls",
            "paused": "Paused controls.",
            "resume": "Resume Voice Controls",
            "dictationPlay": "Start Dictation Mode",
            "dictationPause": "Stop Dictation Mode",
            "prompt": "Start speaking to see your voice controls here...",
            "dictationPrompt": "Start speaking to type what you say...",
            "latency": "High latency detected. Consider closing some applications that might be consuming too many resources.",
            "noDeviceConnectedDescription": "The microphone control serves as a preview of the interface. No steps will be successfully executed. Connect this companion device to another, in order to initiate commands.",
            "status": {
                "loadingModel": "Loading Voice Model...",
                "loadingPhiModel": "Loading Text Generation Model...",
                "preparingPhiModel": "Preparing Text Generation Model...",
                "generatingText": "Generating...",
                "thinking": "Thinking...",
                "paused": "Paused.",
                "dictating": "Dictating.",
                "optimistic": "Optimistic:",
                "listening": "Listening:",
                "permission": "Checking microphone permissions...",
                "typing": "Typing..."
            }
        },
        "edit": {
            "title": "Edit Microphone Settings",
            "description": "Manage your voice commands and dictation settings for this connection.",
            "autoStart": {
                "title": "Automatically Start Microphone",
                "description": "With this setting turned on, your input device will turn on the microphones and start processing voice controls once it starts up after you plug it in or turn it on. If this is off, you need to tap the Start Listening button in your connection page.",
                "option": "Autostart Microphone and Voice Controls?"
            },
            "optimistic": {
                "title": "Optimistic Voice Controls",
                "description": "Cephable has two different sensitivity modes for voice controls - Standard and Optimistic. Standard mode allows Cephable to recognize all words in its understanding and can be used with dictation mode. Optimistic mode tells Cephable to focus more on the voice controls in your given app controls. With Optimistic mode on, your voice controls will trigger faster but you can also accidentally trigger your control if you don't say the exact word. Optimistic mode does not allow for dictation.",
                "option": "Use Optimistic Voice Controls?"
            },
            "aiCommands": {
                "title": "Intelligent Voice Commands",
                "description": "Intelligent voice commands allow Cephable AI to predict voice commands you are trying to use without needing to exactly match. It allows you to more naturally tell your computer what to do and Cephable helps figure it out.",
                "option": "Use Intelligent Voice Commands?"
            },
            "aiDictation": {
                "title": "Intelligent Dictation and Quick Type",
                "description": "Intelligent Dictation and Quick Type deliver the most accurate on-device input experience available. Dictation handles punctuation, proper nouns, and sentence structure automatically, while Quick Type provides smart predictions and corrections that help you write with ease and accuracy.",
                "option": "Use Intelligent Dictation and Quick Type?"
            },
            "confirm": {
                "title": "You have unsaved changes.",
                "description": "Detected unsaved changes. Would you like to save before exiting?"
            }
        },
        "devices": {
            "error": "Microphone Input Device Not Found."
        }
    },
    "localization": {
        "title": "Language Settings",
        "titleShort": "Language",
        "select": "Select Language",
        "description": "Choose your preferred language from a list of supported languages.",
        "newUserDescription": "Please select a preferred language before continuing.",
        "edit": "Update Language",
        "profile": {
            "view": "Variants",
            "title": "App Control Language",
            "question": "What app control language would you like to edit?",
            "description": "Some app controls have variants for different languages. Swap to another language to edit and personalize.",
            "change": "Change Language"
        },
        "display": {
            "title": "Display Language",
            "description": "Language that is displayed when using Cephable. This includes things like menus, notifications, and app controls being displayed in the language of your choice.."
        },
        "voice": {
            "title": "Voice Control Language",
            "description": "This is the language that is used when recognizing dictation and voice commands. Specifying the language enhances the accuracy of your voice inputs.",
            "settings": {
                "title": "Voice Recognition and Display Language",
                "description": "Adjust your language settings for both display and voice controls. This option allows you to select your preferred languages for on-screen text and microphone interactions like voice controls and dictation."
            }
        },
        "unsupported": {
            "title": "Unsupported Language {{locale}}",
            "description": "The selected language is not supported. Please choose a different language."
        },
        "locales": {
            "en": "English",
            "en-us": "English (US)",
            "en-gb": "English (UK)",
            "en-in": "English (India)",
            "es": "Español — Spanish",
            "fr": "Français — French",
            "it": "Italiano — Italian",
            "de": "Deutsch — German",
            "ja": "日本語 — Japanese"
        },
        "localesShort": {
            "en": "English",
            "en-us": "English (US)",
            "es": "Spanish",
            "fr": "French",
            "it": "Italian",
            "de": "German",
            "ja": "Japanese"
        },
        "save": {
            "success": "User locale preferences saved!",
            "error": "Error saving user locale preferences"
        }
    },
    "editor": {
        "title": "Markdown Editor",
        "bold": "Bold",
        "italic": "Italic",
        "underline": "Underline",
        "strikethrough": "Strikethrough",
        "hr": "Horizontal Rule",
        "link": "Link",
        "quote": "Quote",
        "code": "Code",
        "codeBlock": "Code Block",
        "comment": "Comment",
        "image": "Image",
        "table": "Table",
        "unordered-list": "Unordered List",
        "ordered-list": "Ordered List",
        "checked-list": "Checked List",
        "help": "Help",
        "edit": "Edit",
        "live": "Live",
        "preview": "Preview",
        "fullscreen": "Fullscreen",
        "placeholder": "Please enter Markdown text here..."
    },
    "panel": {
        "title": "Cephable Panel",
        "titleShort": "Panel",
        "description": "This is the panel which is the main control center. It is always visible and allows you to control your apps using your voice, and more.",
        "question": "Autostart Panel?",
        "position": {
            "top": "Top",
            "right": "Right",
            "left": "Left",
            "bottom": "Bottom ",
            "description": "Select where you want the Cephable Panel to appear on your screen.",
            "label": "Position"
        },
        "sections": {
            "description": "Choose what sections in the panel are visible. You can hide sections based on your preferences to make the most of the panel space.",
            "microphone": "Microphone and Voice Controls",
            "camera": "Camera and Face/Head Controls",
            "buttons": "Quick Action Buttons",
            "tasks": "Intelligent Tasks",
            "profile": "App Controls and Previews",
            "globalControls": "Global and Device Controls"
        }
    },
    "smartTasks": {
        "title": "Intelligent Tasks",
        "show": "Show Intelligent Tasks",
        "description": "Intelligent tasks are the different tasks that Cephable's AI can perform for you. These tasks are powered by on-device AI and can be used to create text, summarize, rewrite, translate and more.",
        "clearCache": "If you see issues with generating, please clear your cache and resources from Text Generation Settings and try again.",
        "networkError": "Connection lost while downloading the model. Please check your internet connection and try again by submitting a prompt or restarting the app.",
        "genericError": "An unexpected error occurred. Please try again.",
        "generatedByAI": "Powered by on-device AI, please review for accuracy.",
        "highlightText": {
            "title": "Use highlighted text",
            "description": "Cephable can automatically use the text you have highlighted in any app to perform tasks like summarizing, rewriting, or translating. You can also enter text manually if you prefer.",
            "label": "Enter text to use",
            "placeholder": "You can also highlight text in another app and come back here to use it."
        },
        "pasteText": {
            "title": "Paste text",
            "description": "Cephable can automatically use the text you have copied to your clipboard to perform tasks like summarizing, rewriting, or translating. You can also enter text manually if you prefer.",
            "label": "Enter text to use",
            "placeholder": "You can also highlight text in another app and come back here to use it."
        },
        "generateText": {
            "title": "Generate Text",
            "description": "Create text content based on your input or prompts.",
            "label": "Describe what you want to generate"
        },
        "summarizeText": {
            "title": "Summarize Text",
            "titleShort": "Summarize",
            "write": "Write Summary",
            "description": "Condense lengthy text into a concise summary.",
            "directions": "Enter the text to summarize, or Cephable will automatically use whatever text you have highlighted.",
            "label": "Enter text to summarize",
            "outputLabel": "Your summary will write here."
        },
        "rewriteText": {
            "title": "Rewrite Text",
            "description": "Highlight text in another app where you are writing and then come back here and describe how you want it to be re-written.",
            "label": "Describe how you want to rewrite the text",
            "inputLabel": "Enter text to rewrite"
        },
        "translateText": {
            "title": "Translate Text",
            "description": "Enter the text to translate, or Cephable will automatically use whatever text you have highlighted.",
            "label": "Enter text to translate",
            "languageLabel": "Language to translate to"
        },
        "transcribeAudio": {
            "title": "Transcribe Audio",
            "description": "Convert audio or video files to text using AI transcription.",
            "inputMethod": "Choose input method",
            "localFile": "Local File",
            "url": "URL",
            "selectFile": "Select Audio/Video File",
            "urlLabel": "Audio/Video URL",
            "transcribe": "Transcribe",
            "result": "Transcription Result",
            "invalidFileType": "Please select a valid audio or video file (mp3, wav, ogg, mp4, webm, mov, avi)",
            "error": "Transcription error",
            "history": {
                "title": "Transcription History",
                "description": "View and manage your saved transcriptions.",
                "viewHistory": "View History",
                "empty": "No transcriptions yet. Start transcribing to build your history!",
                "titleLabel": "Title (optional)",
                "titlePlaceholder": "Enter a title for this transcription",
                "textLabel": "Transcription Text",
                "confirmDelete": "Are you sure you want to delete this transcription?"
            }
        },
        "noteTaker": {
            "title": "Note Taker",
            "description": "Let Cephable locally record and transcribe your meetings or conversations"
        },
        "documentChat": {
            "title": "Document Chat",
            "description": "Interact with and query documents for quick insights."
        },
        "aiWorkflows": {
            "title": "AI Workflows",
            "description": "Automate your desktop and browser tasks with AI. Simply describe what you want to accomplish, and watch Cephable execute the actions for you.",
            "introModal": {
                "title": "Your AI Workflows Are Ready",
                "description": "I can now automate your desktop and browser tasks — just tell me what you want done, and I'll handle the steps. I run privately on your device, so your data stays yours. To get started, I need to download a local AI model. Download it now so I can be ready, or I'll grab it when you kick off your first workflow.",
                "confirm": "Download Now",
                "cancel": "Skip for Now"
            },
            "label": "What can I help you do?",
            "start": "Start",
            "progress": "Working...",
            "ready": {
                "waiting": "AI Workflows is ready. Waiting for your instructions.",
                "execute": "AI Workflows is ready. Starting on your request..."
            },
            "status": {
                "idle": "Waiting for your instructions...",
                "initializing": "Getting things ready...",
                "planning": [
                    "Making a plan...",
                    "Breaking down your request...",
                    "Mapping out the steps...",
                    "Organizing the workflow...",
                    "Preparing the strategy...",
                    "Creating a plan of action...",
                    "Figuring out the best way to help you...",
                    "Determining how to approach this...",
                    "Analyzing your request...",
                    "Planning the execution..."
                ],
                "thinking": [
                    "Thinking...",
                    "Analyzing your request...",
                    "Figuring out the best way to help you...",
                    "Determining what to do next...",
                    "Processing the previous steps...",
                    "Working on your request...",
                    "Fetching details...",
                    "Reviewing the plan...",
                    "Considering the options...",
                    "Creating, Evaluating, Deciding..."
                ],
                "thinkingInteractive": [
                    "Considering the next step...",
                    "Reviewing what we've done so far...",
                    "Deciding what to do next...",
                    "Analyzing the results...",
                    "Planning the continuation...",
                    "Evaluating the options...",
                    "Figuring out the best next step...",
                    "Working on the next part of your request...",
                    "Working on the next steps...",
                    "Processing the previous step's results..."
                ],
                "waitingForUser": "Your input is needed to continue.",
                "completed": "Success!",
                "failed": "Your request failed: {{message}}",
                "networkError": "Connection lost while downloading the model. Please check your internet connection and try again by submitting a prompt or restarting the app.",
                "canceled": "Your request was canceled.",
                "terminated": "Stopped. Waiting for your instructions...",
                "executing-org-block": "Cannot {{params.toolName}} because interacting with {{params.appOrDomain}} is blocked by the organization.",
                "executing-destructive-block": "Interacting with {{params.elementName}} is blocked. Please review and perform this action manually.",
                "executing-type-focus-block": "I had an issue writing the content. It is copied to your clipboard, please paste it manually.",
                "tools": {
                    "click_element_by_index": {
                        "executing-start": "Clicking the relevant button...",
                        "executing-complete": "I clicked {{params.index}}."
                    },
                    "click_element": {
                        "executing-start": "Clicking the highlighted number...",
                        "executing-complete": "I clicked {{params.elementName}}."
                    },
                    "copy_selection": {
                        "executing-start": "Gathering context...",
                        "executing-complete": "I have context, ready for the next part of your request."
                    },
                    "create_file": {
                        "executing-start": "Creating a file...",
                        "executing-complete": "I created a file named {{params.fileName}}."
                    },
                    "draft_email": {
                        "executing-start": "Drafting an email...",
                        "executing-complete": "I drafted an email about {{params.subject}}."
                    },
                    "execute_app_action": {
                        "executing-start": "Running {{params.actionName}}...",
                        "executing-complete": "{{params.actionName}} completed."
                    },
                    "find_all_text": {
                        "executing-start": "Searching for all relevant context about {{params.searchText}}...",
                        "executing-complete": "I found all relevant context about {{params.searchText}}."
                    },
                    "find_and_select_text": {
                        "executing-start": "Searching and selecting relevant context about {{params.searchText}}...",
                        "executing-complete": "I found and selected relevant context about {{params.searchText}}."
                    },
                    "generate_text": {
                        "executing-start": "Creating content...",
                        "executing-progress": "Creating content...{{progress}}%",
                        "executing-complete": "I created the requested content."
                    },
                    "get_all_interactive_elements": {
                        "executing-start": "Scanning to get more context...",
                        "executing-complete": "I understand what I can interact with."
                    },
                    "get_all_text_elements_content": {
                        "executing-start": "Reading to get more context...",
                        "executing-complete": "I understand what text content is available."
                    },
                    "get_all_text_elements_names": {
                        "executing-start": "Reading to get more context...",
                        "executing-complete": "I understand what text content is available."
                    },
                    "get_available_profile_actions": {
                        "executing-start": "Checking what controls are available in this app...",
                        "executing-complete": "I understand what I can do in this app."
                    },
                    "get_document_content": {
                        "executing-start": "Reading to get more context...",
                        "executing-complete": "I have context, ready for the next part of your request."
                    },
                    "get_installed_apps": {
                        "executing-start": "Deciding which app is relevant to your request...",
                        "executing-complete": "I know which apps I can use."
                    },
                    "get_running_app_names": {
                        "executing-start": "Deciding which app is relevant to your request...",
                        "executing-complete": "I know which apps I can use."
                    },
                    "get_selected_text": {
                        "executing-start": "Reading the selected content...",
                        "executing-complete": "I have context on the selected content."
                    },
                    "get_stored_content": {
                        "executing-start": "Gathering context...",
                        "executing-complete": "I have context, ready for the next part of your request."
                    },
                    "keyboard_shortcut": {
                        "executing-start": "Gathering context...",
                        "executing-complete": "I have context, ready for the next part of your request."
                    },
                    "open_app": {
                        "executing-start": "Opening {{params.appName}}...",
                        "executing-complete": "I opened {{params.appName}}."
                    },
                    "open_webpage": {
                        "executing-start": "Opening {{params.url}}...",
                        "executing-complete": "I opened {{params.url}}."
                    },
                    "paste_content": {
                        "executing-start": "Writing...",
                        "executing-complete": "I finished writing."
                    },
                    "respond_to_user": {
                        "executing-start": "Completing your request...",
                        "executing-complete:": "I completed your request."
                    },
                    "search_and_open_file": {
                        "executing-start": "Searching for the file {{params.query}} and opening it...",
                        "executing-complete": "I searched for the file {{params.query}} and opened it."
                    },
                    "search_browser": {
                        "executing-start": "Searching the web for {{params.query}}...",
                        "executing-complete": "I searched the web for {{params.query}}."
                    },
                    "select_all_text": {
                        "executing-start": "Selecting all the text...",
                        "executing-complete": "I selected all the text."
                    },
                    "summarize_text": {
                        "executing-start": "Summarizing the text...",
                        "executing-progress": "Summarizing...{{progress}}%",
                        "executing-complete": "I summarized the text."
                    },
                    "translate_text": {
                        "executing-start": "Translating the text to {{params.targetLanguage}}...",
                        "executing-progress": "Translating...{{progress}}%",
                        "executing-complete": "I translated the text to {{params.targetLanguage}}."
                    },
                    "type_stored_content": {
                        "executing-start": "Writing...",
                        "executing-complete": "I finished writing."
                    },
                    "type_text": {
                        "executing-start": "Writing...",
                        "executing-complete": "I finished writing."
                    },
                    "write_file_content": {
                        "executing-start": "Writing to the file...",
                        "executing-complete": "I finished writing to the file {{params.fileName}}."
                    },
                    "unknown": {
                        "executing-start": "Ran into a problem, trying a different strategy...",
                        "executing-complete": "I tried a different strategy."
                    }
                }
            }
        }
    },
    "tray": {
        "panel": "Toggle Panel",
        "dashboard": "Show Dashboard",
        "quit": "Quit Cephable"
    },
    "metrics": {
        "download": {
            "success": "Metrics file successfully accessed.",
            "manualPath": "Metrics file available at: {{path}}",
            "error": "Error downloading metrics file.",
            "noFile": "No metrics file found."
        },
        "clear": {
            "success": "Metrics file cleared successfully.",
            "error": "Error clearing metrics file.",
            "noFile": "No metrics file found to clear.",
            "confirm": "Are you sure you want to clear all metrics data? This cannot be undone."
        }
    },
    "gamepad": {
        "title": "Gamepad Support",
        "description": "Configure gamepad and joystick output for PC gaming",
        "driver": {
            "description": "To support game controller outputs, Cephable needs to download and install an external driver called ViGEm. This driver enables virtual Xbox 360 controller functionality that games recognize natively.",
            "installed": "Game controller driver installed - You're ready to use gamepad outputs! If you're still facing issues, you can try reinstalling the driver.",
            "notInstalled": "Game controller driver not installed",
            "install": "Install Game Controller Driver",
            "reinstall": "Reinstall Game Controller Driver",
            "installing": "Installing ViGEm game controller driver...",
            "installSuccess": "ViGEm game controller driver installed successfully! You can now use gamepad outputs in your controls.",
            "installFailed": "Failed to install ViGEm driver. Please try again or install manually from the ViGEm website."
        },
        "platform": {
            "unsupported": "Platform not supported for gamepad features",
            "unsupportedDescription": "Gamepad output functionality is currently only supported on Windows x64 systems. Windows ARM64 support is not yet available due to SDK limitations."
        },
        "usage": "Once the Game Controller driver is installed, you can use joystick movements and gamepad button presses in your macros and voice commands to control games."
    },
    "youtube": {
        "unavailable": {
            "title": "Video Unavailable",
            "description": "This video is currently unavailable. Please check again later.",
            "retry": "Retry"
        },
        "watch": {
            "title": "Oops.",
            "description": "Looks like there was an issue loading the video. You can watch it directly on YouTube.",
            "button": "Watch on YouTube"
        },
        "offline": {
            "title": "Video Unavailable",
            "description": "This YouTube video requires an internet connection to load. Please check your connection and try again."
        }
    },
    "accessibilityService": {
        "error": {
            "generic": "Internal Error. Please try again later.",
            "elementNotFound": "No result found. Please ensure the search exists and try again.",
            "highlightOnConflict": "Multiple elements found. Please refine your command to specify which one you want to select.",
            "clickNotInitialized": "Tapping by Name is not available at the moment. Please contact support if the issue persists.",
            "platformUnsupported": "Voice Mouse features are not supported on this platform."
        },
        "clickWait": "Still initializing. Please wait a moment and try again."
    },
    "tos": {
        "title": "Terms of Service Update",
        "description": "Our Terms of Service have been updated. Please review and accept the updated terms to continue using Cephable.",
        "effectiveDate": "Effective date: {{date}}",
        "accept": "Accept Terms of Service",
        "loadError": "Unable to load Terms of Service. Please try again.",
        "viewInBrowser": "View Terms of Service In Browser",
        "acceptCheckbox": "I have read and accept the Terms of Service"
    }
}
